import Pie2DDataset, {labelClickFn, plotClickHandler, hideFn} from './pie2d';
import { ZEROSTRING, touchEnabled, pluck, toRaphaelColor, preDefStr,
  getPosition, fcEach, getFirstValue, pluckNumber,
  hasSVG, normalizeAngle, extend2 } from '../../_internal/lib/lib';
import { convertColor, getDarkColor, getLightColor, rawRGBtoHEX } from '../lib/lib-graphics';
import ComponentInterface from '../../core/component-interface';
import { _getInnerSize } from './doughnut2d';
import pie3dAnimation from '../animation-rules/pie3d-animation';
import { getDep, addDep } from '../../_internal/dependency-manager';
import raphaelShapesLitepath from '../redraphael/redraphael-shapes/redraphael-shapes.litepath';

let Raphael = getDep('redraphael', 'plugin'),
  win = window,
  UNDEF,
  HIDDEN = 'hidden',
  docMode8 = window.document.documentMode === 8,
  VISIBLE = docMode8 ? 'visible' : '',
  COMMASTRING = ',',
  ROLLOVER = 'DataPlotRollOver',
  ROLLOUT = 'DataPlotRollOut',
  EVENTARGS = 'eventArgs',
  GROUPID = 'groupId',
  POINTER = 'pointer',
  elementStr = preDefStr.elementStr,
  M = 'M',
  L = 'L',
  V = 'v',
  A = 'A',
  Z = 'Z',
  math = Math,
  mathMax = math.max,
  mathMin = math.min,
  mathAbs = math.abs,
  mathCeil = math.ceil,
  mathSin = math.sin,
  mathATan2 = math.atan2,
  mathCos = math.cos,
  mathFloor = math.floor,
  mathRound = math.round,
  pi = math.PI,
  pi2 = 2 * pi,
  piBy2 = pi / 2,
  pi3By2 = pi + piBy2,
  getAbsScaleAngle = function (start, end) {
    return (start > end ? pi2 : 0) + end - start;
  },
  map = function (arr, fn) {
    var results = [],
      i = 0,
      len = arr.length;

    for (; i < len; i++) {
      results[i] = fn.call(arr[i], arr[i], i, arr);
    }
    return results;
  },
  defined = function (obj) {
    return obj !== UNDEF && obj !== null;
  },
  isObject = function (obj) {
    return typeof obj === 'object';
  },
  isString = function (s) {
    return typeof s === 'string';
  },
  pInt = function (s, mag) {
    return parseInt(s, mag || 10);
  },
  pie3DCacheColorStore = {
    lighting3D: {

    },
    lighting2D: {

    }
  },
  getClickArcTangent = function (x, y, center, ref, pieYScale) {
    return mathATan2((y - center[1] - ref.top) / pieYScale, x - center[0] - ref.left);
  },
  plotRollOver = function (e) {
    var plotItem = this.data('plotItem'),
      index = plotItem.index,
      chart = plotItem.chart,
      animationManager = chart.getFromEnv('animationManager'),
      chartConfig = chart.config,
      dataSet = chart.getChildren('dataset')[0],
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      data = dataSetComponents.data[index],
      setGraphics = data.graphics,
      setConfig = data.config,
      element = setGraphics.element,
      hoverEffects = setConfig.hoverEffects;
    if (!dataSetConfig.isRotating) {
      chart.plotEventHandler(element, e, ROLLOVER);
      hoverEffects.enabled && animationManager.setAnimation({
        el: element,
        attr: hoverEffects,
        component: dataSet
      });
    }
    chartConfig.isHovered = true;
  },
  plotRollOut = function (e) {
    var plotItem = this.data('plotItem'),
      index = plotItem.index,
      chart = plotItem.chart,
      animationManager = chart.getFromEnv('animationManager'),
      chartConfig = chart.config,
      dataSet = chart.getChildren('dataset')[0],
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      data = dataSetComponents.data[index],
      setGraphics = data.graphics,
      setConfig = data.config,
      element = setGraphics.element;

    if (!dataSetConfig.isRotating) {
      chart.plotEventHandler(element, e, ROLLOUT);
      animationManager.setAnimation({
        el: element,
        attr: {
          color: setConfig.color.color.split(',')[0],
          alpha: setConfig._3dAlpha,
          borderWidth: setConfig.borderWidth,
          borderColor: setConfig.borderColor
        },
        component: dataSet
      });
    }
    chartConfig.isHovered = false;
  },
  plotDragStart = function (evt) {
    var plotItem = this.data('plotItem'),
      chart = plotItem.chart,
      dataSet = chart.getChildren('dataset')[0],
      button = pluckNumber(evt.button, evt.originalEvent.button),
      dataSetConfig = dataSet.config,
      angle,
      x = evt.data[0],
      y = evt.data[1];

    dataSetConfig.isRightClicked = !!(!touchEnabled && (button !== 0 && button !== 1));
    if (!dataSetConfig.enableRotation || dataSetConfig.isRightClicked) {
      return;
    }

    dataSetConfig.isRotating = false;
    angle = getClickArcTangent.call(evt, x, y, dataSetConfig.center,
      (dataSetConfig.chartPosition = getPosition(dataSet.getFromEnv('chart-container'))), dataSetConfig.pieYScale);
    dataSetConfig.dragStartAngle = angle;
    dataSetConfig._lastAngle = -dataSetConfig.startAngle;
    dataSetConfig.startingAngleOnDragStart = dataSetConfig.startAngle;
  },
  plotDragEnd = function () {
    var plotItem = this.data('plotItem'),
      index = plotItem.index,
      chart = plotItem.chart,
      animationManager = chart.getFromEnv('animationManager'),
      chartConfig = chart.config,
      dataSet = chart.getChildren('dataset')[0],
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      data = dataSetComponents.data[index],
      setGraphics = data.graphics,
      setConfig = data.config,
      element = setGraphics.element,
      startingAng = dataSetConfig.startAngle;
      // save state
      /* reflowUpdate = {
          hcJSON: {
              series: [ {
                  startAngle: startingAng
              }]
          }
      }; */
      /* if (!chart.disposed) {
          extend2 (chart.logic.chartInstance.jsVars._reflowData,
                      reflowUpdate, true);
      } */

    if (dataSetConfig.isRightClicked) {
      return;
    }
    if (dataSetConfig.isRotating) {
      /* The events mouseup, dragend and click are raised in order. In order
        * to update the flag isRotating to false post click event, setTimeout
        * called, to take immediate effect, is programmed to update the flag.
        * Thus, the flag gets updated post the series of events, in effect.
        * NB: Click event is subscribed conditionally.
        */
      setTimeout(function () {
        dataSetConfig.isRotating = false;
      }, 0);
      /**
               * @event FusionCharts#rotationEnd
               * @group chart:pie-slice
               *
               * @param { number} startingAngle - The initial angle. (desc)
               * @param { number} changeInAngle - It is the difference between the starting angle and the starting
               * angle on the drag start.
               */
      chart.fireChartInstanceEvent('rotationEnd', {
        startingAngle: normalizeAngle(startingAng, true),
        changeInAngle: startingAng - dataSetConfig.startingAngleOnDragStart
      });
      // if not hovered on this plot and rotation End then undo hovereffect from plot
      !chartConfig.isHovered && animationManager.setAnimation({
        el: element,
        attr: {
          color: setConfig.color.color.split(',')[0],
          alpha: setConfig._3dAlpha,
          borderWidth: setConfig.borderWidth,
          borderColor: setConfig.borderColor
        },
        component: dataSet
      });
    }
  },
  plotDragMove = function (evt) {
    var plotItem = this.data('plotItem'),
      chart = plotItem.chart,
      evtData = evt.data,
      dx = evtData[0],
      dy = evtData[1],
      x = evtData[2],
      y = evtData[3],
      dataSet = chart.getChildren('dataset')[0],
      dataSetConfig = dataSet.config,
      angle,
      currentTime,
      deltaAngle;

    if (isNaN(dx) || isNaN(dy) || !dataSetConfig.enableRotation || dataSetConfig.singletonCase ||
      dataSetConfig.isRightClicked) {
      return;
    }

    angle = getClickArcTangent.call(evt, x, y, dataSetConfig.center,
      dataSetConfig.chartPosition, dataSetConfig.pieYScale);

    if (dataSetConfig.dragStartAngle !== angle && !dataSetConfig.isRotating) {
      dataSetConfig.isRotating = true;
      /**
       * This event is fired when a pie or doughnut chart's rotation is triggered.
       *
       * @event FusionCharts#rotationStart
       * @group chart:pie-slice
       * @param { number} startingAngle - This indicates the angle from where rotation started.
       */
      chart.fireChartInstanceEvent('rotationStart',
        {startingAngle: normalizeAngle(dataSetConfig.startAngle, true)});
    }

    deltaAngle = angle - dataSetConfig.dragStartAngle;

    dataSetConfig.dragStartAngle = angle;
    dataSetConfig.moveDuration = 0;

    dataSetConfig._lastAngle += (deltaAngle * 180 / pi);
    currentTime = new Date().getTime();

    if (!dataSetConfig._lastTime || (dataSetConfig._lastTime + dataSetConfig.timerThreshold <
              currentTime)) {
      if (!dataSetConfig._lastTime) {
        dataSet._rotate();
      }
      dataSetConfig.timerId = setTimeout(function () {
        if (!chart.disposed || !chart.disposing) {
          dataSet._rotate();
        }
      }, dataSetConfig.timerThreshold);
      dataSetConfig._lastTime = currentTime;
    }
  },
  elementZSortFn = function (a, b) {
    var centerAngleDiff = (a._conf.index - b._conf.index) || (a._conf.cIndex - b._conf.cIndex) ||
              (a._conf.isStart - b._conf.isStart) || (a._conf.si - b._conf.si);
    // !centerAngleDiff && console.log("aaa");
    return centerAngleDiff;
  },
  getStartIndex = function (array) {
    var l,
      i,
      startsAtFrontHalf,
      startIndex = array[0] && array[0]._conf.index,
      atFrontHalf,
      index;

    startsAtFrontHalf = startIndex <= pi;
    for (i = 1, l = array.length; i < l; i += 1) {
      index = array[i]._conf.index;
      atFrontHalf = index <= pi;
      if (atFrontHalf !== startsAtFrontHalf || index < startIndex) {
        return i;
      }
    }
    return 0;
  },
  /*
   * Pie Helper Functions.
   */
  sortArrayByPoint = function (a, b) {
    return a.point.value - b.point.value;
  },
  sortArrayByAngle = function (a, b) {
    return a.angle - b.angle;
  },
  alignments = ['start', 'start', 'end', 'end'],
  alignCenter = 'middle',
  ySign = [-1, 1, 1, -1],
  xSign = [1, 1, -1, -1],
  attrKeyList = {
    // block following attribute
    stroke: true,
    strokeWidth: true,
    'stroke-width': true,
    dashstyle: true,
    'stroke-dasharray': true,
    translateX: true,
    translateY: true,
    'stroke-opacity': true,
    fill: true,
    'fill-opacity': true,
    opacity: true,
    // attribute that has direct effect
    transform: true,
    cursor: true,
    sAngle: true,
    eAngle: true,
    color: true,
    alpha: true,
    borderColor: true,
    borderAlpha: true,
    borderWidth: true,
    rolloverProps: true,
    showBorderEffect: true,
    positionIndex: true,
    cx: true,
    cy: true,
    radiusYFactor: true,
    r: true,
    innerR: true
  },
  attrFN = function (hash, val) {
    var key,
      value,
      slice = this,
      confObject = slice._confObject,
      commonAttr = {},
      elements = confObject.elements,
      x,
      updateShape,
      updateColor,
      Pie3DManager = confObject.Pie3DManager,
      applyCommonAttr;

    // single key-value pair
    if (isString(hash) && defined(val)) {
      key = hash;
      hash = {};
      hash[key] = val;
    }

    // used as a getter: first argument is a string, second is undefined
    if (!hash || isString(hash)) {
      if (attrKeyList[hash]) {
        slice = confObject[hash];
      } else {
        slice = slice._attr(hash);
      }
      // setter
    } else {
      for (key in hash) {
        value = hash[key];

        // if belongs from the list then handle here
        if (attrKeyList[key]) {
          // store the att in confObject for further use
          confObject[key] = value;
          if (key === 'cursor' || key === 'transform' ||
                          key === 'opacity' || key === 'fill-opacity') {
            commonAttr[key] = value;
            applyCommonAttr = true;
          } else if (key === 'sAngle' || key === 'eAngle' || key === 'cx' || key === 'cy' ||
                          key === 'radiusYFactor' || key === 'r' || key === 'innerR') {
            updateShape = true;
          } else if (key === 'color' || key === 'alpha' || key === 'borderColor' ||
                          key === 'borderAlpha' || key === 'borderWidth') {
            updateColor = true;
          }
        } else { // else leve for the original attr
          slice._attr(key, value);
        }
      }

      // if paths need to be updated
      if (updateShape) {
        Pie3DManager._setSliceShape(confObject);
        // refreash the drawinh for proper z lavel for elements
        Pie3DManager.refreshDrawing();
      }
      // if colors need to be updated
      // If the shape got changed, then also cange the color
      if (updateColor || updateShape) {
        Pie3DManager._setSliceCosmetics(confObject);
      }
      // apply common attributes
      if (applyCommonAttr) {
        // other elements
        for (x in elements) {
          elements[x].attr(commonAttr);
        }
        // main element
        slice._attr(commonAttr);
      }
    }
    return slice;
  },
  onFN = function (eventType, handler, callFromRaphael) {
    if (callFromRaphael) {
      this._on(eventType, handler, true);
      return;
    }
    var slice = this,
      confObject = slice._confObject,
      elements = confObject.elements,
      element;

    for (element in elements) {
      elements[element].on(eventType, handler);
    }
    return slice._on(eventType, handler);
  },
  onDragFN = function (dragStart, dragMove, dragEnd) {
    var element,
      slice = this,
      confObject = slice._confObject,
      elements = confObject.elements,
      navigator = win.navigator,
      ua = navigator.userAgent.toLowerCase(),
      isAndroid = ua.indexOf('android') > -1;
    for (element in elements) {
      if (isAndroid) {
        if (element === 'topBorder' || element === 'frontOuter' || element === 'startSlice' ||
                      element === 'endSlice') {
          elements[element].drag(dragStart, dragMove, dragEnd);
        }
      } else {
        elements[element].drag(dragStart, dragMove, dragEnd);
      }
    }
    return slice._drag(dragStart, dragMove, dragEnd);
  },
  hideFN = function () {
    var slice = this,
      confObject = slice._confObject,
      elements = confObject.elements,
      element;

    for (element in elements) {
      elements[element].hide();
    }
    return slice._hide();
  },
  showFN = function () {
    var slice = this,
      confObject = slice._confObject,
      elements = confObject.elements,
      element;

    for (element in elements) {
      elements[element].show();
    }
    return slice._show();
  },
  destroyFN = function () {
    var confObject = this._confObject,
      elements = confObject.elements, x;
    // other elements
    for (x in elements) {
      elements[x].destroy();
    }
    if (hasSVG) {
      // destory other element
      // TODO: Check whether this clip elements are not destroying from else where
      confObject.clipTop.destroy();
      confObject.clipOuterFront.destroy();
      confObject.clipOuterBack.destroy();
      if (confObject.clipOuterFront1) {
        confObject.clipOuterFront1.destroy();
      }
      if (confObject.clipInnerFront) {
        confObject.clipInnerFront.destroy();
      }
      if (confObject.clipInnerBack) {
        confObject.clipInnerBack.destroy();
      }
    }
    // main element
    return this._destroy();
  },
  dataFN = function (key, value) {
    var slice = this,
      confObject = slice._confObject,
      elements = confObject.elements,
      element;
    if (value === UNDEF) {
      return slice._data(key);
    } else {
      // other elements
      for (element in elements) {
        elements[element].data(key, value);
      }
      // main element
      return slice._data(key, value);
    }
  },
  si = 0; // slice index
addDep({
  name: 'pie3dAnimation',
  type: 'animationRule',
  extension: pie3dAnimation
});
class Pie3DDataset extends Pie2DDataset {
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.setBorderWidth = UNDEF;
    config.alphaanimation = 0;
    config.showBorderEffect = UNDEF;
  }
  placeDataLabels (isRotating) {
    var attr,
      // prevTextPos,
      dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      toolTipController = chart.getFromEnv('toolTipController'),
      chartConfig = chart.config,
      plotOptions = dataSet.config,
      plotItems = dataSet.components.data,
      piePlotOptions = plotOptions.piePlotOptions,
      canvasLeft = chartConfig.canvasLeft,
      canvasTop = chartConfig.canvasTop,
      canvasWidth = chartConfig.canvasWidth,
      cx = canvasLeft + chartConfig.canvasWidth * 0.5,
      cy = canvasTop + chartConfig.canvasHeight * 0.5,
      smartLabel = chart.getFromEnv('smartLabel'),
      dataLabelsOptions = plotOptions.dataLabelOptions,
      style = dataLabelsOptions.style,
      lineHeight = pluckNumber(mathCeil(parseFloat(style.lineHeight)), 12),
      placeInside = getFirstValue(dataLabelsOptions.placeInside, false),
      skipOverlapLabels = dataLabelsOptions.skipOverlapLabels,
      manageLabelOverflow = dataLabelsOptions.manageLabelOverflow,
      connectorPadding = dataLabelsOptions.connectorPadding,
      distanceOption = dataLabelsOptions.distance,
      connectorWidth = dataLabelsOptions.connectorWidth,
      remainingHeight,
      // divide the points into quarters for anti collision
      quarters = [
        [], // top right
        [], // bottom right
        [], // bottom left
        [] // top left
      ],
      // todo remove the dupliace variables.
      plotLeft = canvasLeft,
      plotTop = canvasTop,
      plotWidth = canvasWidth,
      labelFontSize = parseInt(style.fontSize, 10),
      labelHeight = labelFontSize,
      halfLabelHeight = labelHeight / 2,
      xDisplacement = [connectorPadding,
        connectorPadding, -connectorPadding, -connectorPadding
      ],
      isSmartLineSlanted = dataLabelsOptions.isSmartLineSlanted,
      align,
      i,
      labelWidth,
      j,
      oriY,
      maxYmayHave,
      spaceRequired,
      length,
      k,
      sliced,
      x1,
      x2,
      x3,
      x4,
      y1,
      y2,
      y3,
      points,
      point,
      angle,
      excess,
      excessArr,
      dataLabel,
      dataLabelCheck,
      quarter,
      transX,
      transY,
      smartLabelObj,
      pointConfig,
      pointGraphics,
      connector,
      connectorPath,
      outside = distanceOption > 0,
      center = plotOptions.center || (plotOptions.center = [
        cx,
        cy,
        piePlotOptions.size,
        (piePlotOptions.innerSize || 0)
      ]),
      centerY = center[1],
      centerX = center[0],
      radius = center[2],
      radiusY = center[4],
      dataLabelsRadius = plotOptions.labelsRadius,
      dataLabelsRadiusY = mathRound(plotOptions.labelsRadiusY * 100) / 100,
      maxLabels = plotOptions.maxLabels,
      enableSmartLabels = plotOptions.enableSmartLabels,
      labelQuardentHeight,
      maxQuardentLabel,
      pieSliceDepthHalf = plotOptions.pieSliceDepth / 2,
      _textCss,
      _textAttrs,
      animationManager = chart.getFromEnv('animationManager'),
      dataLabelContainer = dataSet.getContainer('label-group');

    smartLabel.useEllipsesOnOverflow(chartConfig.useEllipsesWhenOverflow);
    // save the world if there is no labels to be placed.
    if (!plotOptions.dataLabelCounter) {
      return;
    }
    if (!isRotating) {
      // do not set the style every time
      // Do it for first time
      smartLabel.setStyle(style);
    }
    // arrange points for detection collision
    // Creates an array of quarter containing labels of each quarter
    // if there has only one label the draw it inside
    if (plotItems.length == 1) {
      point = plotItems[0];
      pointGraphics = point.graphics;
      pointConfig = point.config;
      _textAttrs = pointConfig._textAttrs;
      _textCss = pointConfig._textCss;
      dataLabel = pointGraphics.label;
      connector = pointGraphics.connector;
      pointConfig.slicedTranslation = [plotLeft, plotTop];
      if (pointConfig.y !== null && pointConfig.y !== UNDEF) {
        _textAttrs.visibility = VISIBLE;
        _textAttrs['text-anchor'] = alignCenter;
        _textAttrs.x = centerX;
        _textAttrs.y = centerY + halfLabelHeight - 2;

        _textAttrs._x = centerX;
      }

      _textCss.cursor = pointConfig.labellink ? 'pointer' : '';
      dataLabel = pointGraphics.label = animationManager.setAnimation({
        el: pointGraphics.label || 'text',
        attr: _textAttrs,
        css: _textCss,
        label: 'label',
        container: dataLabelContainer,
        component: dataSet
      });

      dataLabel.on('dragstart', plotDragStart)
        .on('dragmove', plotDragMove)
        .on('dragend', plotDragEnd)
        .on('click', labelClickFn.bind(dataLabel, chart, point.config.labellink))
        .on('mouseup', plotClickHandler(dataSet, dataLabel))
        .hover(plotRollOver, plotRollOut);

      if (_textAttrs._x) {
        dataLabel.x = _textAttrs._x;
        delete _textAttrs.x;
      }
      dataLabel
        .data('plotItem', _textAttrs.plotItem)
        .data(EVENTARGS, _textAttrs.eventArgs);

      if (_textAttrs.visibility === VISIBLE) {
        dataLabel.show();
      }

      if (connector) {
        connector.hide();
      }
    } else {
      if (placeInside) {
        fcEach(plotItems, function (point) {
          var slicedTranslation,
            transX,
            transY;

          pointGraphics = point.graphics;
          pointConfig = point.config;
          _textAttrs = pointConfig._textAttrs;
          dataLabel = pointGraphics.label;
          if (pointConfig.y !== null && pointConfig.y !== UNDEF) {
            angle = pointConfig.angle;
            y3 = centerY + (center[6] * mathSin(angle)) + halfLabelHeight - 2;
            x3 = centerX + (center[5] * mathCos(angle));
            _textAttrs._x = x3;
            _textAttrs._y = y3;
            if (pointConfig.sliced) {
              slicedTranslation = point.slicedTranslation;
              transX = slicedTranslation[0] - plotLeft;
              transY = slicedTranslation[1] - plotTop;
              x3 = x3 + transX;
              y3 = y3 + transY;
            }
            _textAttrs.visibility = VISIBLE;
            _textAttrs.align = alignCenter;
            _textAttrs.x = x3;
            _textAttrs.y = y3;
          }
          _textCss.cursor = pointConfig.labellink ? 'pointer' : '';
          dataLabel = pointGraphics.label = animationManager.setAnimation({
            el: pointGraphics.label || 'text',
            attr: _textAttrs,
            css: _textCss,
            label: 'label',
            container: dataLabelContainer,
            component: dataSet
          });

          dataLabel.data('plotItem', _textAttrs.plotItem)
            .data(EVENTARGS, _textAttrs.eventArgs);

          if (_textAttrs.visibility === VISIBLE) {
            dataLabel.show();
          }

          dataLabel.x = _textAttrs._x;
          dataLabel._x = _textAttrs._x;
          dataLabel._y = _textAttrs._y;
        });
      } else { // outside
        fcEach(plotItems, function (point) {
          pointGraphics = point.graphics;
          pointConfig = point.config;
          _textCss = pointConfig._textCss;
          _textAttrs = pointConfig._textAttrs;
          if (!(_textAttrs.text = pointConfig.displayValue)) {
            pointGraphics.connector && animationManager.setAnimation({
              el: pointGraphics.connector,
              component: dataSet,
              callback: hideFn
            });
            pointGraphics.label && animationManager.setAnimation({
              el: pointGraphics.label,
              component: dataSet,
              callback: hideFn
            });
            return;
          }
          pointGraphics = point.graphics;
          if (pointConfig.y !== null && pointConfig.y !== UNDEF) {
            dataLabel = pointGraphics.label;
            connector = pointGraphics.connector;
            connector && connector.show();
            dataLabel && dataLabel.show();
          }

          dataLabel = pointGraphics.label;

          angle = pointConfig.angle;

          if (angle < 0) {
            angle = pi2 + angle;
          }
          // Calculate top right quarter labels
          if (angle >= 0 && angle < piBy2) {
            quarter = 1;
          } else
          // Calculate bottom right quarter labels
          if (angle < pi) {
            quarter = 2;
          } else
          // Calculate bottom left quarter labels
          if (angle < (pi3By2)) {
            quarter = 3;
          } else {
            // Calculate bottom left quarter labels
            quarter = 0;
          }
          // Now put labels according to each quarter
          quarters[quarter].push({
            point: point,
            angle: angle
          });

          /* dataLabel = pointGraphics.label;
          if (dataLabel) {
              angle = pointConfig.angle;

              if (angle < 0) {
                  angle = pi2 + angle;
              }
              // Calculate top right quarter labels
              if (angle >= 0 && angle < piBy2) {
                  quarter = 1;
              } else
              // Calculate bottom right quarter labels
              if (angle < pi) {
                  quarter = 2;
              } else
              // Calculate bottom left quarter labels
              if (angle < (pi3By2)) {
                  quarter = 3;
              }
              // Calculate bottom left quarter labels
              else {
                  quarter = 0;
              }
              // Now put labels according to each quarter
              quarters[quarter].push ( {
                  point : point,
                  angle : angle
              });
          } */
        });

        i = 4;
        // if excess then remove the low value slice first
        while (i--) {
          if (skipOverlapLabels) {
            // Find labels can fit into the quarters or not
            excess = quarters[i].length - maxLabels;
            if (excess > 0) {
              quarters[i].sort(sortArrayByPoint); // sort by point.y
              // remove extra data form the array
              // which labels can not be fitted into the quarters
              excessArr = quarters[i].splice(0, excess);
              // hide all removed labels
              for (j = 0, length = excessArr.length; j < length; j += 1) {
                point = excessArr[j].point;
                pointGraphics = point.graphics;
                if (pointGraphics.label) {
                  animationManager.setAnimation({
                    el: pointGraphics.label,
                    attr: {'visibility': HIDDEN},
                    component: dataSet
                  });
                }
                if (pointGraphics.connector) {
                  animationManager.setAnimation({
                    el: pointGraphics.connector,
                    attr: {visibility: HIDDEN},
                    component: dataSet
                  });
                }
              }
            }
          }
          // now we sort the data labels by its label angle
          quarters[i].sort(sortArrayByAngle);
        }

        maxQuardentLabel = mathMax(
          quarters[0].length,
          quarters[1].length,
          quarters[2].length,
          quarters[3].length
        );
        labelQuardentHeight = mathMax(
          mathMin(maxQuardentLabel, maxLabels) * labelHeight,
          dataLabelsRadiusY + labelHeight
        );

        // reverse 1st and 3rd quardent points
        quarters[1].reverse();
        quarters[3].reverse();
        smartLabel.setStyle(style);
        k = 4;
        while (k--) {
          points = quarters[k];
          length = points.length;

          if (!skipOverlapLabels) {
            if (length > maxLabels) {
              labelHeight = labelQuardentHeight / length;
            } else {
              labelHeight = labelFontSize;
            }
            halfLabelHeight = labelHeight / 2;
          }

          // 1st pass
          // place all labels at 1st quarter

          // calculate the total available space to put labels
          spaceRequired = length * labelHeight;
          // calculate the remaining height
          remainingHeight = labelQuardentHeight;
          // place all child point
          for (i = 0; i < length; i += 1, spaceRequired -= labelHeight) {
            // Get the y position of the label (radius where data label is to draw)
            oriY = mathAbs(labelQuardentHeight * mathSin(points[i].angle));
            if (remainingHeight < oriY) {
              oriY = remainingHeight;
            } else if (oriY < spaceRequired) {
              oriY = spaceRequired;
            }
            remainingHeight = (points[i].oriY = oriY) - labelHeight;
          }

          // 2nd pass (reverse)
          align = alignments[k];
          // place all labels at 1st quarter
          maxYmayHave = labelQuardentHeight - ((length - 1) * labelHeight);
          remainingHeight = 0;

          // place all child point
          for (i = points.length - 1; i >= 0; i -= 1, maxYmayHave += labelHeight) {
            point = points[i].point;
            pointGraphics = point.graphics;
            pointConfig = point.config;
            _textAttrs = pointConfig._textAttrs;
            _textCss = pointConfig._textCss;

            if (pointConfig.y === null || !_textAttrs.text) {
              continue;
            }
            angle = points[i].angle;
            sliced = pointConfig.sliced;
            dataLabel = pointGraphics.label;

            oriY = mathAbs(labelQuardentHeight * mathSin(angle));

            if (oriY < remainingHeight) {
              oriY = remainingHeight;
            } else if (oriY > maxYmayHave) {
              oriY = maxYmayHave;
            }

            remainingHeight = oriY + labelHeight;

            y1 = ((oriY + points[i].oriY) / 2);
            x1 = centerX + xSign[k] * dataLabelsRadius * mathCos(math.asin(y1 /
                                labelQuardentHeight));

            y1 *= ySign[k];
            y1 += centerY;

            y2 = centerY + (radiusY * mathSin(angle));
            x2 = centerX + (radius * mathCos(angle));

            // Relation: centerX <= connectorStartX <= connectorEndX (for right half and vice
            // versa for left half)
            ((k < 2 && x1 < x2) || (k > 1 && x1 > x2)) && (x1 = x2);

            x3 = x1 + xDisplacement[k];
            y3 = y1 + halfLabelHeight - 2;
            x4 = x3 + xDisplacement[k];

            _textAttrs._x = x4;

            if (manageLabelOverflow) {
              labelWidth = k > 1 ? x4 - canvasLeft : canvasLeft + plotWidth - x4;
              smartLabel.setStyle(pointConfig.style);
              lineHeight = pluckNumber(mathCeil(parseFloat(pointConfig.style.lineHeight)),
                12) + ((mathCeil(parseFloat(pointConfig.style.border), 12) * 2) || 0);
              smartLabelObj = smartLabel.getSmartText(pointConfig.displayValue, labelWidth,
                lineHeight);
              _textAttrs.text = smartLabelObj.text;
              _textAttrs.tooltip = smartLabelObj.tooltext;
            }

            // shift the labels at front pieSliceDepthHalf
            if (angle < pi) {
              y1 += pieSliceDepthHalf;
              y2 += pieSliceDepthHalf;
              y3 += pieSliceDepthHalf;
            }
            _textAttrs._y = y3;
            // dataLabel.y = y3;
            if (sliced) {
              transX = pointConfig.transX;
              transY = pointConfig.transY;
              x3 = x3 + transX;
              x1 = x1 + transX;
              x2 = x2 + transX;
              y2 = y2 + transY;
              x4 = x4 + transX;
            }
            _textAttrs.visibility = VISIBLE;
            _textAttrs['text-anchor'] = align;
            _textAttrs.x = x4;
            _textAttrs.y = y1;
            _textAttrs.opacity = 1;

            _textCss.cursor = pointConfig.labellink ? 'pointer' : '';
            dataLabelCheck = pointGraphics.label;
            dataLabel = animationManager.setAnimation({
              el: dataLabelCheck || 'text',
              attr: _textAttrs,
              css: _textCss,
              container: dataLabelContainer,
              component: dataSet,
              label: 'label'
            });
            dataLabel.data('textPos', {
              x: x4,
              y: y1
            }).data('plotItem', _textAttrs.plotItem)
              .data(EVENTARGS, _textAttrs.eventArgs);
            if (!dataLabelCheck) {
              // asssign events on label only on initial creation
              pointGraphics.label = dataLabel;
              dataLabel.on('dragstart', plotDragStart)
                .on('dragmove', plotDragMove)
                .on('dragend', plotDragEnd)
                .on('click', labelClickFn.bind(dataLabel, chart, point.config.labellink))
                .on('mouseup', plotClickHandler(dataSet, dataLabel))
                .hover(plotRollOver, plotRollOut);
            }

            dataLabel.x = _textAttrs._x;
            // storing original x value
            // to use while slicing in (IE Issue original x get changed form animate)
            dataLabel._x = _textAttrs._x;
            dataLabel.y = _textAttrs._y;

            if (_textAttrs.tooltip) {
              toolTipController.enableToolTip(dataLabel, _textAttrs.tooltip);
              delete _textAttrs.tooltip;
            }
            // draw the connector
            // draw the connector
            if (outside && connectorWidth && enableSmartLabels) {
              connector = pointGraphics.connector;
              // if (!pointConfig.connectorPath) {
              //   isNewElem = true;
              // }
              pointConfig.connectorPath = connectorPath = [
                M,
                x2, y2, // base
                L,
                isSmartLineSlanted ? x1 : x2, y1, // first break, next to the label
                x3, y1 // end of the string at the label
              ];

              attr = {
                path: connectorPath,
                'stroke-width': connectorWidth,
                stroke: dataLabelsOptions.connectorColor || '#606060',
                opacity: 1,
                visibility: VISIBLE
              };
              if (connector) {
                animationManager.setAnimation({
                  el: connector,
                  attr: attr,
                  label: 'connector',
                  component: dataSet
                });
              }
            }
          }
        }
      }
    }
  }
  _parsePie3DOptions () {
    var dataSet = this,
      conf = dataSet.config;
    return {
      size: 2 * conf.pieMinRadius,
      slicedOffset: conf.slicingDistance,
      allowPointSelect: true,
      cursor: POINTER,
      innerSize: dataSet.getName() === 'pie3d' ? 0 : _getInnerSize.call(dataSet)
    };
  }
  // Some border properties of PIE3D varies from that of its 2d counter part
  _parseBorderConfig (setColor, setAlpha, dataJSON) {
    var dataSet = this,
      conf = dataSet.config,
      pieBorderColor = conf.pieBorderColor,
      chartAttr = dataSet.getFromEnv('chart-attrib'),
      // each slice border color
      setPlotBorderColor = pluck(dataJSON.bordercolor, pieBorderColor),
      // each slice border alpha
      setPlotBorderAlpha = pluck(dataJSON.borderalpha, chartAttr.plotborderalpha,
        chartAttr.pieborderalpha);

    setPlotBorderColor = pluck(setPlotBorderColor, getLightColor(setColor, 90)).split(COMMASTRING)[0];
    setPlotBorderAlpha = chartAttr.showplotborder == ZEROSTRING ?
      ZEROSTRING : pluck(setPlotBorderAlpha, setAlpha, '80');
    return {
      setPlotBorderColor: setPlotBorderColor,
      setPlotBorderAlpha: setPlotBorderAlpha
    };
  }
  // Initialising the pie3D manager class.
  _initPie3dManager () {
    var i,
      point,
      dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      chartConfig = chart.config,
      precision = 1000,
      total = 0,
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      dataLabelOptions = dataSetConfig.dataLabelOptions,
      pie3DOptions = (dataSetConfig.pie3DOptions = dataSet._parsePie3DOptions()),
      startingAngle = (pluck(dataSetConfig.startAngle, 0) % pi2),
      fontSize,
      managedPieSliceDepth = dataSetConfig.managedPieSliceDepth,
      slicedOffset = dataSetConfig.slicedOffset = pie3DOptions.slicedOffset,
      plotWidth = chartConfig.canvasWidth,
      plotHeight = chartConfig.canvasHeight,
      positions = [chartConfig.canvasLeft + plotWidth * 0.5,
        chartConfig.canvasTop + plotHeight * 0.5 - managedPieSliceDepth * 0.5],
      start,
      pointConfig,
      end,
      angle,
      lastEnd,
      maxEnd,
      data = dataSetComponents.data,
      fraction,
      smallestSize = mathMin(plotWidth, plotHeight),
      isPercent,
      radiusX, // the x component of the radius vector for a given point
      radiusY,
      labelDistance = dataLabelOptions.distance,
      pieYScale = dataSetConfig.pieYScale,

      slicedOffsetY = dataSetConfig.slicedOffsetY || (dataSetConfig.slicedOffsetY =
                  slicedOffset * dataSetConfig.pieYScale),
      pie3DManager = dataSet.getFromEnv('pie3DManager');

    // get positions - either an integer or a percentage string must be given
    positions.push((2 * dataSetConfig.pieMinRadius), pie3DOptions.innerSize || 0);

    positions = map(positions, function (length, i) {
      isPercent = /%$/.test(length);
      return isPercent ?
        // i == 0: centerX, relative to width
        // i == 1: centerY, relative to height
        // i == 2: size, relative to smallestSize
        // i == 4: innerSize, relative to smallestSize
        [plotWidth, plotHeight - managedPieSliceDepth, smallestSize, smallestSize][i] *
              pInt(length) / 100 :
        length;
    });

    // convert all diameter into radius
    positions[2] /= 2;
    positions[3] /= 2;
    // Add the ry
    positions.push(positions[2] * pieYScale);
    // centerRadiusX
    positions.push((positions[2] + positions[3]) / 2);
    // centerRadiusY
    positions.push(positions[5] * pieYScale);

    // utility for getting the x value from a given y, used for anticollision logic in data labels
    dataSet.getX = function (y, left) {
      angle = math.asin((y - positions[1]) / (positions[2] + labelDistance));

      return positions[0] +
              (left ? -1 : 1) *
              (mathCos(angle) * (positions[2] + labelDistance));
    };

    // set center for later use
    dataSetConfig.center = positions;

    // get the total sum
    fcEach(data, function (point) {
      total += point.config.y;
    });

    dataSetConfig.labelsRadius = positions[2] + labelDistance;
    dataSetConfig.labelsRadiusY = dataSetConfig.labelsRadius * pieYScale;
    dataSetConfig.quadrantHeight = (plotHeight - managedPieSliceDepth) / 2;
    dataSetConfig.quadrantWidth = plotWidth / 2;

    lastEnd = startingAngle;

    lastEnd = mathRound(lastEnd * precision) / precision;
    maxEnd = lastEnd + pi2;

    fontSize = pluckNumber(parseInt(dataLabelOptions.style.fontSize, 10), 10) + 4; // 2px padding
    dataSetConfig.maxLabels = mathFloor(dataSetConfig.quadrantHeight / fontSize); // max labels per quarter
    dataSetConfig.labelFontSize = fontSize;
    dataSetConfig.connectorPadding = pluckNumber(dataLabelOptions.connectorPadding, 5);
    dataSetConfig.isSmartLineSlanted = pluck(dataLabelOptions.isSmartLineSlanted, true);
    dataSetConfig.connectorWidth = pluckNumber(dataLabelOptions.connectorWidth, 1);
    dataSetConfig.enableSmartLabels = dataLabelOptions.enableSmartLabels;
    if (!pie3DManager) {
      pie3DManager = new Pie3DManager(chart);
      dataSet.attachChild(pie3DManager, 'pie3DManager', false);
      dataSet.addToEnv('pie3DManager', pie3DManager);
    }
    dataSet._configurePie3DManager();

    // each (data, function (point) {
    for (i = data.length - 1; i >= 0; i -= 1) {
      point = data[i];
      pointConfig = point.config;
      // set start and end angle
      start = lastEnd;
      fraction = total ? pointConfig.y / total : 0;

      lastEnd = mathRound((lastEnd + (fraction * pi2)) * precision) / precision;
      if (lastEnd > maxEnd) {
        lastEnd = maxEnd;
      }
      end = lastEnd;

      // set the shape
      pointConfig.shapeArgs = {
        sAngle: mathRound(start * precision) / precision,
        eAngle: mathRound(end * precision) / precision
      };

      // center for the sliced out slice
      pointConfig.centerAngle = angle = ((end + start) / 2) % pi2;
      // TODO: slicedTranslation is implemented as string
      pointConfig.slicedTranslation = [
        mathRound(mathCos(angle) * slicedOffset),
        mathRound(mathSin(angle) * slicedOffsetY)
      ];

      // set the anchor point for tooltips
      radiusX = mathCos(angle) * positions[2];
      dataSetConfig.radiusY = radiusY = mathSin(angle) * positions[4];
      pointConfig.tooltipPos = [
        positions[0] + radiusX * 0.7,
        positions[1] + radiusY// changed to reducr mouce on tooltip condition
      ];

      // API properties
      pointConfig.percentage = fraction * 100;
      pointConfig.total = total;
    }
  }
  _configurePie3DManager () {
    var dataSet = this,
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      pie3DManager = dataSet.getFromEnv('pie3DManager'),
      data = dataSetComponents.data;

    if (pie3DManager) {
      pie3DManager.configure(dataSetConfig.pieSliceDepth, data.length === 1, dataSetConfig.use3DLighting,
        false);
    }
  }

  allocatePosition () {
    var dataset = this,
      chart = dataset.getFromEnv('chart'),
      chartConfig = chart.config,
      dataSetConfig = dataset.config,
      plotData = dataset.components.data,
      i,
      precision = 1000,
      dataObj,
      startingAngle = (pluck(dataSetConfig.startAngle, 0) % pi2),
      lastEnd = startingAngle,
      start,
      end,
      point,
      fraction,
      isPercent,
      pie3DOptions = (dataSetConfig.pie3DOptions = dataset._parsePie3DOptions()),
      pieYScale = dataSetConfig.pieYScale,
      managedPieSliceDepth = dataSetConfig.managedPieSliceDepth,
      plotWidth = chartConfig.canvasWidth,
      plotHeight = chartConfig.canvasHeight,
      smallestSize = mathMin(plotWidth, plotHeight),
      positions = [chartConfig.canvasLeft + plotWidth * 0.5,
        chartConfig.canvasTop + plotHeight * 0.5 - managedPieSliceDepth * 0.5],
      total = 0,
      maxEnd,
      len = plotData.length;

    // get positions - either an integer or a percentage string must be given
    positions.push((2 * dataSetConfig.pieMinRadius), pie3DOptions.innerSize || 0);

    positions = map(positions, function (length, i) {
      isPercent = /%$/.test(length);
      return isPercent ?
        // i == 0: centerX, relative to width
        // i == 1: centerY, relative to height
        // i == 2: size, relative to smallestSize
        // i == 4: innerSize, relative to smallestSize
        [plotWidth, plotHeight - managedPieSliceDepth, smallestSize, smallestSize][i] *
              pInt(length) / 100 :
        length;
    });

    // convert all diameter into radius
    positions[2] /= 2;
    positions[3] /= 2;
    // Add the ry
    positions.push(positions[2] * pieYScale);
    // centerRadiusX
    positions.push((positions[2] + positions[3]) / 2);
    // centerRadiusY
    positions.push(positions[5] * pieYScale);

    dataSetConfig.center = positions;
    // get the total sum
    fcEach(plotData, function (point) {
      total += point.config.y;
    });
    lastEnd = mathRound(lastEnd * precision) / precision;
    maxEnd = lastEnd + pi2;
    for (i = plotData.length - 1; i >= 0; i -= 1) {
      point = plotData[i];
      start = lastEnd;
      fraction = total ? point.config.y / total : 0;

      lastEnd = mathRound((lastEnd + (fraction * pi2)) * precision) / precision;
      if (lastEnd > maxEnd) {
        lastEnd = maxEnd;
      }
      end = lastEnd;

      // set the shape
      point.config.shapeArgs = {
        sAngle: mathRound(start * precision) / precision,
        eAngle: mathRound(end * precision) / precision
      };
    }

    for (i = 0; i < len; i++) {
      dataObj = plotData[i];
      dataset.parsePlotAttributes(dataObj, i);
      dataset.parseLabelAttributes(dataObj, i);
    }
  }
  parsePlotAttributes (set, index) {
    var positions,
      pieYScale,
      dataSet = this,
      dataSetComponents = dataSet.components,
      dataSetConfig = dataSet.config,
      chart = dataSet.getFromEnv('chart'),
      chartConfig = chart.config,
      plotData = dataSetComponents.data,
      dataLabelOptions = dataSetConfig.dataLabelOptions,
      style = dataLabelOptions.style,
      slicedOffset = dataSetConfig.slicingDistance,
      slicedOffsetY = dataSetConfig.slicedOffsetY || (dataSetConfig.slicedOffsetY = slicedOffset * dataSetConfig.pieYScale),
      showBorderEffect = dataSetConfig.showBorderEffect,
      dataLength = plotData.length,
      colorLabelFromPoint = dataSetConfig.usePerPointLabelColor,
      textDirection = chartConfig.textDirection,
      eventArgs,
      plotItem,
      val,
      displayValue,
      setLink,
      sliced,
      angle,
      connectorWidth,
      shapeArgs,
      toolText,
      setConfig,
      dataLabel,
      connector,
      i = index,
      isTranspose,
      _textAttrs,
      _textCss,
      setElAttr,
      connectorAttr,
      setElCosmetics = {},
      prevPositions,
      dataLabelStyle = chartConfig.dataLabelStyle;

    positions = dataSetConfig.center;
    prevPositions = dataSetConfig.prevPositions || positions;
    pieYScale = dataSetConfig.pieYScale;
    setConfig = set.config;
    if (!(_textAttrs = setConfig._textAttrs)) {
      _textAttrs = setConfig._textAttrs = {};
    }
    if (!(_textCss = setConfig._textCss)) {
      _textCss = setConfig._textCss = {};
    }

    val = setConfig.y;
    displayValue = setConfig.displayValue;
    sliced = setConfig.sliced;
    shapeArgs = setConfig.shapeArgs;
    angle = setConfig.centerAngle;
    toolText = setConfig.toolText;
    setLink = !!setConfig.link;
    style = setConfig.style;

    if (val === null || val === UNDEF) {
      // todo: update null data.
      return;
    }

    setElAttr = {
      sAngle: shapeArgs.sAngle,
      eAngle: shapeArgs.eAngle,
      r: !isTranspose ? positions[2] : prevPositions[2],
      innerR: !isTranspose ? positions[3] : prevPositions[3],
      cx: !isTranspose ? positions[0] : prevPositions[0],
      cy: !isTranspose ? positions[1] : prevPositions[1],
      radiusYFactor: pieYScale,
      opacity: 1
    };

    if (displayValue !== UNDEF) {
      // If data label cosmetics exists.
      if (style) {
        if (!(_textCss = setConfig._textCss)) {
          _textCss = setConfig._textCss = {};
        }
        _textCss.fontFamily = style.fontFamily;
        _textCss.fontSize = style.fontSize;
        _textCss.lineHeight = style.lineHeight;
        _textCss.fontWeight = style.fontWeight;
        _textCss.fontStyle = style.fontStyle;
      } else if (setConfig._textCss) {
        /* If there was a perviously applied cosmetics for a data Object, need to restore the chart
        Label styling to it. */
        dataLabel && dataLabel.removeCSS();
        delete setConfig._textCss;
        _textCss = UNDEF;
      }

      setConfig.style = (style || (style = dataLabelStyle));
      _textAttrs.text = displayValue;
      _textAttrs.fill = (colorLabelFromPoint ? toRaphaelColor(setConfig.color) :
        style.color) || '#000000';
      _textAttrs['text-bound'] = [style.backgroundColor, style.borderColor,
        style.borderThickness, style.borderPadding,
        style.borderRadius, style.borderDash];
      _textAttrs.direction = textDirection;
      _textAttrs.lineHeight = style.lineHeight;

      if (dataLabel) {
        if (_textCss) {
          delete _textCss.fontFamily;
          delete _textCss.fontSize;
          delete _textCss.lineHeight;
          delete _textCss.fontWeight;
          delete _textCss.fontStyle;
          _textCss = UNDEF;
        }
      }
      if (dataLabelOptions.distance > 0 &&
                      (connectorWidth = dataLabelOptions.connectorWidth) &&
                                     dataLabelOptions.enableSmartLabels) {
        connectorAttr = {
          'stroke-width': connectorWidth,
          stroke: dataLabelOptions.connectorColor || '#606060',
          cursor: setLink ? POINTER : '',
          opacity: 1
        };
      }
    } else {
      _textAttrs.text = '';
    }

    setConfig.plotItem = plotItem = {
      chart: chart,
      index: i,
      seriesData: dataSetConfig,
      value: val,
      angle: (setConfig.angle = angle),
      link: setConfig.link,
      shapeArgs: shapeArgs,
      slicedX: sliced && !dataSetConfig.singletonCase ? mathCos(angle) * slicedOffset : 0,
      slicedY: sliced && !dataSetConfig.singletonCase ? mathSin(angle) * slicedOffsetY : 0,
      sliced: sliced,
      labelText: displayValue,
      name: setConfig.name,
      percentage: setConfig.percentage,
      toolText: toolText,
      originalIndex: dataLength - i - 1,
      style: setConfig.style,
      // graphic: setElement,
      transX: (setConfig.transX = mathCos(angle) * slicedOffset),
      transY: (setConfig.transY = mathSin(angle) * slicedOffsetY),
      slicedTranslation: (setConfig.slicedTranslation = 't' + setConfig.transX + ',' +
                      setConfig.transY),
      label: dataLabel,
      connector: connector
    };

    setConfig.eventArgs = eventArgs = {
      index: dataSetConfig.reversePlotOrder ? dataLength - 1 - i : i,
      link: setConfig.link,
      value: setConfig.y,
      displayValue: setConfig.displayValueArgs,
      categoryLabel: setConfig.categoryLabel,
      isSliced: setConfig.sliced,
      toolText: setConfig.toolText
    };

    setElCosmetics = {
      color: setConfig.color.color.split(',')[0],
      alpha: setConfig._3dAlpha,
      borderWidth: setConfig.borderWidth,
      borderColor: setConfig.borderColor,
      borderAlpha: setConfig.borderConfig.setPlotBorderAlpha
    };

    extend2(setElAttr, setElCosmetics);

    setElAttr.cursor = setLink ? POINTER : '';
    setElAttr.showBorderEffect = showBorderEffect;

    setElAttr.transform = 't' + plotItem.slicedX + ',' + plotItem.slicedY;
    _textAttrs.plotItem = plotItem;
    _textAttrs[EVENTARGS] = eventArgs;

    setConfig.props = {
      element: {
        attr: setElAttr
      },
      connector: {
        attr: connectorAttr
      },
      label: {
        attr: _textAttrs,
        css: _textCss
      }
    };
  }
  draw () {
    var positions,
      pieYScale,
      dataSet = this,
      dataSetComponents = dataSet.components,
      dataSetConfig = dataSet.config,
      chart = dataSet.getFromEnv('chart'),
      chartConfig = chart.config,
      animationManager = chart.getFromEnv('animationManager'),
      // state,
      plotData = dataSetComponents.data,
      pie3DManager,
      dataLabelOptions = dataSetConfig.dataLabelOptions,
      style = dataLabelOptions.style,
      slicedOffset = dataSetConfig.slicingDistance,
      slicedOffsetY = dataSetConfig.slicedOffsetY || (dataSetConfig.slicedOffsetY = slicedOffset * dataSetConfig.pieYScale),
      showBorderEffect = dataSetConfig.showBorderEffect,
      dataLength = plotData.length,
      colorLabelFromPoint = dataSetConfig.usePerPointLabelColor,
      textDirection = chartConfig.textDirection,
      eventArgs,
      plotItem,
      set,
      val,
      valueTotal = dataSetConfig.valueTotal,
      displayValue,
      setLink,
      sliced,
      angle,
      connectorWidth,
      shapeArgs,
      toolText,
      setConfig,
      setGraphics,
      dataLabel,
      removeDataArr = dataSetComponents.removeDataArr || [],
      connector,
      visible = dataSet.getState('visible'),
      i,
      // callBackCalled = false,
      // datasetGraphics = dataSet.graphics,
      // dataLabelContainer = datasetGraphics.dataLabelContainer,
      dataLabelContainer = dataSet.getContainer('labelGroup'),
      plotGroup,
      isTranspose,
      setElement,
      _textAttrs,
      _textCss,
      setElAttr,
      connectorAttr,
      isnewElem,
      element,
      sliceElements,
      setElCosmetics = {},
      prevPositions,
      toolTipController = dataSet.getFromEnv('toolTipController'),
      showDataLabels = function () {
        dataLabelContainer.show();
        dataSet.placeDataLabels(false);
      },
      dataLabelStyle = chartConfig.dataLabelStyle;

    if (!dataSet.getContainer('pie-groups')) {
      dataSet._createContainer();
    }
    dataLabelContainer = dataSet.getContainer('label-group');
    plotGroup = dataSet.getContainer('plot-group');

    animationManager.setAnimation({
      el: dataLabelContainer,
      attr: { css: dataLabelStyle },
      component: dataSet,
      label: 'labelcontainer',
      callback: function () {
        // hide all groups if dataset is not visible.
        if (!visible || !valueTotal) {
          dataLabelContainer.hide();
          plotGroup.hide();
        } else {
          dataLabelContainer.show();
          plotGroup.show();
        }
      }
    });

    // does the initialising tasks and calculations before the actual rendering.
    dataSet._initPie3dManager();
    pie3DManager = dataSet.getFromEnv('pie3DManager');
    // Remove extra plots
    removeDataArr.length && dataSet.remove();

    positions = dataSetConfig.center;
    prevPositions = dataSetConfig.prevPositions || positions;
    pieYScale = dataSetConfig.pieYScale;

    // Spare the world if no data has been sent
    if (!(plotData && dataLength)) {
      plotData = [];
    }

    i = -1;
    while (++i < dataLength) {
      set = plotData[i];
      setConfig = set.config;
      if (!(_textAttrs = setConfig._textAttrs)) {
        _textAttrs = setConfig._textAttrs = {};
      }

      setGraphics = set.graphics;
      val = setConfig.y;
      displayValue = setConfig.displayValue;
      sliced = setConfig.sliced;
      shapeArgs = setConfig.shapeArgs;
      angle = setConfig.centerAngle;
      toolText = setConfig.toolText;
      setLink = !!setConfig.link;
      style = setConfig.style;

      if (val === null || val === UNDEF) {
        // todo: update null data.
        continue;
      }

      setElement = setGraphics.element;
      dataLabel = setGraphics.label;
      connector = setGraphics.connector;
      setElAttr = {
        sAngle: shapeArgs.sAngle,
        eAngle: shapeArgs.eAngle,
        r: !isTranspose ? positions[2] : prevPositions[2],
        innerR: !isTranspose ? positions[3] : prevPositions[3],
        cx: !isTranspose ? positions[0] : prevPositions[0],
        cy: !isTranspose ? positions[1] : prevPositions[1],
        radiusYFactor: pieYScale,
        opacity: 1
      };
      // create the element if not available.
      if (!setElement) {
        isnewElem = true;
        // pick from the pool (maintained by Pie3dManager).
        setElement = setGraphics.element = pie3DManager.useSliceFromPool();
        if (!setElement) {
          setElement = setGraphics.element = pie3DManager.createSlice()
            .drag(plotDragMove, plotDragStart, plotDragEnd)
            .mouseover(plotRollOver)
            .mouseout(plotRollOut);
          setElement.on('mouseup', plotClickHandler(dataSet, setElement));
        }
      } else {
        isnewElem = false;
      }
      if (displayValue !== UNDEF) {
        // If data label cosmetics exists.
        if (style) {
          if (!(_textCss = setConfig._textCss)) {
            _textCss = setConfig._textCss = {};
          }
          _textCss.fontFamily = style.fontFamily;
          _textCss.fontSize = style.fontSize;
          _textCss.lineHeight = style.lineHeight;
          _textCss.fontWeight = style.fontWeight;
          _textCss.fontStyle = style.fontStyle;
        } else if (setConfig._textCss) {
          /* If there was a perviously applied cosmetics for a data Object, need to restore the chart
          Label styling to it. */
          dataLabel && dataLabel.removeCSS();
          delete setConfig._textCss;
          _textCss = UNDEF;
        }

        setConfig.style = (style || (style = dataLabelStyle));
        _textAttrs.text = displayValue;
        _textAttrs.fill = (colorLabelFromPoint ? toRaphaelColor(setConfig.color) :
          style.color) || '#000000';
        _textAttrs['text-bound'] = [style.backgroundColor, style.borderColor,
          style.borderThickness, style.borderPadding,
          style.borderRadius, style.borderDash];
        _textAttrs.direction = textDirection;
        _textAttrs.lineHeight = style.lineHeight;

        if (dataLabel) {
          if (_textCss) {
            animationManager.setAnimation({
              el: dataLabel,
              attr: { css: _textCss },
              component: dataSet
            });
            delete _textCss.fontFamily;
            delete _textCss.fontSize;
            delete _textCss.lineHeight;
            delete _textCss.fontWeight;
            delete _textCss.fontStyle;
            _textCss = UNDEF;
          }
        }
        if (dataLabelOptions.distance > 0 &&
                        (connectorWidth = dataLabelOptions.connectorWidth) &&
                                       dataLabelOptions.enableSmartLabels) {
          connectorAttr = {
            'stroke-width': connectorWidth,
            stroke: dataLabelOptions.connectorColor || '#606060',
            cursor: setLink ? POINTER : '',
            opacity: 1
            // path: 'M 0 0 l 0 0'
          };
          dataLabelContainer.show();
          connector = setGraphics.connector = animationManager.setAnimation({
            el: setGraphics.connector || 'path',
            attr: connectorAttr,
            container: dataLabelContainer,
            label: 'connector',
            component: dataSet
          }).show()
            .on('dragstart', plotDragStart)
            .on('dragmove', plotDragMove)
            .on('dragend', plotDragEnd)
            .hover('plotRollOver', plotRollOver);
        }
      }

      // --when all values of the dataplots are 0--
      if (!valueTotal) {
        dataLabel && dataLabel.hide();
        connector && connector.hide();
      } else {
        dataLabel && dataLabel.show();
        connector && connector.show();
      }

      plotItem = {
        chart: chart,
        index: i,
        seriesData: dataSetConfig,
        value: val,
        angle: (setConfig.angle = angle),
        link: setConfig.link,
        shapeArgs: shapeArgs,
        slicedX: sliced && !dataSetConfig.singletonCase ? mathCos(angle) * slicedOffset : 0,
        slicedY: sliced && !dataSetConfig.singletonCase ? mathSin(angle) * slicedOffsetY : 0,
        sliced: sliced,
        labelText: displayValue,
        name: setConfig.name,
        percentage: setConfig.percentage,
        toolText: toolText,
        originalIndex: dataLength - i - 1,
        style: setConfig.style,
        graphic: setElement,
        transX: (setConfig.transX = mathCos(angle) * slicedOffset),
        transY: (setConfig.transY = mathSin(angle) * slicedOffsetY),
        slicedTranslation: (setConfig.slicedTranslation = 't' + setConfig.transX + ',' +
                        setConfig.transY),
        label: dataLabel,
        connector: connector
      };

      eventArgs = {
        index: dataSetConfig.reversePlotOrder ? dataLength - 1 - i : i,
        link: setConfig.link,
        value: setConfig.y,
        displayValue: setConfig.displayValueArgs,
        categoryLabel: setConfig.categoryLabel,
        isSliced: setConfig.sliced,
        toolText: setConfig.toolText
      };

      setElCosmetics = {
        color: setConfig.color.color.split(',')[0],
        alpha: setConfig._3dAlpha,
        borderWidth: setConfig.borderWidth,
        borderColor: setConfig.borderColor,
        borderAlpha: setConfig.borderConfig.setPlotBorderAlpha
      };

      if (isnewElem) {
        extend2(setElAttr, setElCosmetics);
      }

      setElement.data(GROUPID, i)
        .data('plotItem', plotItem)
        .data(EVENTARGS, eventArgs);

      setElement.data(GROUPID, i)
        .data('plotItem', plotItem)
        .data(EVENTARGS, eventArgs);

      setElAttr.cursor = setLink ? POINTER : '';
      setElAttr.showBorderEffect = showBorderEffect;

      toolTipController.enableToolTip(setElement, toolText);
      sliceElements = setElement._confObject.elements;
      for (element in sliceElements) {
        toolTipController.enableToolTip(sliceElements[element], toolText);
      }
      setElAttr.transform = 't' + plotItem.slicedX + ',' + plotItem.slicedY;
      _textAttrs.plotItem = plotItem;
      _textAttrs[EVENTARGS] = eventArgs;

      animationManager.setAnimation({
        el: setElement,
        attr: setElAttr,
        component: dataSet,
        label: 'slice',
        state: isnewElem ? 'appearing' : 'updating'
      });

      connector && connector.data('plotItem', plotItem)
        .data(EVENTARGS, eventArgs);
    }

    showDataLabels();
    // Marking dataSet drawn
    dataSet.drawn = true;
    // Savinf prev positions
    dataSetConfig.prevPositions = positions.slice(0);
  }
  remove () {
    var dataSet = this,
      conf = dataSet.config,
      components = dataSet.components,
      animationManager = dataSet.getFromEnv('animationManager'),
      removeDataArr = components.removeDataArr || [],
      pool = dataSet.pool = (dataSet.pool = []),
      len = removeDataArr.length,
      pie3DManager = this.getFromEnv('pie3DManager'),
      removeData,
      ele,
      graphics,
      i,
      elem,
      hideFn = function (graphic, type) {
        return function () {
          if (type === elementStr) {
            pie3DManager.removeSlice(graphic.element);
            delete graphic.element;
          } else {
            graphic[type].hide();
          }
        };
      },
      startAngle = conf.startAngle,
      positions = conf.center;
    for (i = 0; i < len; i++) {
      removeData = removeDataArr[0];
      graphics = removeData.graphics;
      for (ele in graphics) {
        elem = graphics[ele];
        if (!pool[ele]) {
          pool[ele] = [];
        }
        if (ele === elementStr) {
          animationManager.setAnimation({
            el: elem,
            attr: {
              sAngle: -startAngle,
              eAngle: -startAngle + 0.01,
              r: positions[2],
              innerR: positions[3],
              cx: positions[0],
              cy: positions[1]
            },
            component: dataSet,
            callback: hideFn(graphics, ele)
          });
        } else {
          animationManager.setAnimation({
            el: elem,
            attr: {
              opacity: 0
            },
            component: dataSet,
            callback: hideFn(graphics, ele)
          });
        }
      }
      removeDataArr.splice(0, 1);
    }
  }
  _rotate (setAngle) {
    var dataSet = this,
      dataSetConfig = dataSet.config,
      animationManager = dataSet.getFromEnv('animationManager'),
      dataSetComponents = dataSet.components,
      data = dataSetComponents.data,
      slicedOffset = dataSetConfig.slicedOffset,
      slicedOffsetY = dataSetConfig.slicedOffsetY,
      startingAngle = dataSetConfig.startAngle,
      pie3DManager = dataSet.getFromEnv('pie3DManager'),
      angle;

    setAngle = !isNaN(setAngle) ? setAngle : -dataSetConfig._lastAngle;

    angle = (setAngle - startingAngle) % 360;

    dataSetConfig.startAngle = pluckNumber(setAngle,
      dataSetConfig.startAngle) % 360;

    angle = -(angle * pi) / 180;

    if (pie3DManager) {
      pie3DManager.rotate(angle);
    }

    fcEach(data, function (point) {
      var slicedTranslation = [],
        pointGraphics = point.graphics,
        pointConfig = point.config,
        element = pointGraphics.element,
        args = pointConfig.shapeArgs,
        newAngleArgs = {
          sAngle: (args.sAngle += angle),
          eAngle: (args.eAngle += angle)
        },
        pointAngle = pointConfig.angle = normalizeAngle((newAngleArgs.sAngle + newAngleArgs.eAngle) / 2),
        sliced = pointConfig.sliced,
        cosAngle = mathCos(pointAngle),
        sinAngle = mathSin(pointAngle);

      // set the  slicedTranslation
      slicedTranslation = pointConfig.slicedTranslation = [
        mathRound(cosAngle * slicedOffset),
        mathRound(sinAngle * slicedOffsetY)
      ];

      pointConfig.transX = slicedTranslation[0];
      pointConfig.transY = slicedTranslation[1];
      pointConfig.slicedX = sliced ? mathCos(angle) * slicedOffset : 0;
      pointConfig.slicedY = sliced ? mathSin(angle) * slicedOffsetY : 0;

      if (element && sliced) {
        animationManager.setAnimation({
          el: element,
          attr: {transform: 't' + slicedTranslation[0] + ',' + slicedTranslation[1]},
          component: dataSet
        });
      }
    });

    dataSet.placeDataLabels(true, data);
  }
  foldingFn () {
    var conf = this.config,
      startAngle = conf.startAngle;
    return {
      sAngle: -startAngle,
      eAngle: -startAngle + 0.01
    };
  }
  /**
   * Returns the type of the component
   * @return {string} type of component
   */
  getType () {
    return 'dataset';
  }
  /**
   * Returns the name of the component
   * @return {string} name of component
   */
  getName () {
    return 'pie3d';
  }
}

// **** pie3d manager ***** //
// set the new animatable properites
if (Raphael && Raphael._availableAnimAttrs && Raphael._availableAnimAttrs.cx) {
  // assuming that cx is also numaric type
  Raphael._availableAnimAttrs.innerR = Raphael._availableAnimAttrs.depth = Raphael._availableAnimAttrs.radiusYFactor =
          Raphael._availableAnimAttrs.sAngle = Raphael._availableAnimAttrs.eAngle = Raphael._availableAnimAttrs.cx;
}

// Adding required shapes for chart.
raphaelShapesLitepath(Raphael);

// Pie 3D point class
class Pie3DManager extends ComponentInterface {
  constructor (chart) {
    super();
    var manager = this;
    manager.config = {};
    manager.linkedItems = {
      chart: chart
    };
  }
  /**
   * Returns the type of the component
   * @return {string} type of component
   */
  getType () {
    return 'pie3DManager';
  }
  /**
   * Returns the name of the component
   * @return {string} name of component
   */
  getName () {
    return 'pie3d';
  }
  /**
   * This function create a new 3d slice and return that for futher use
   * @return {slice} an raphael like composite object that can be used as a slice element
   * TODO: update slice color depending upon angle
   * TODO: For proper z-index create 2 back outer element for larger (>180 deg) slices
   * TODO: Optimize ***** the element creation, instead of outer1, back and from for all elements,
   * create few extra element per manager, which will act as outer1, back / front (inner / outer wall) for
   *  slices, who has both. Because, at max 1 slice can have outer1 and only 2 slice can have
   *   back and front both
   */
  createSlice () {
    let manager = this,
      renderer = manager.renderer,
      returnElement,
      confObject = {
        elements: {},
        Pie3DManager: manager
      },
      slicingWallsArr = manager.slicingWallsArr,
      elements = confObject.elements,
      renderingPath = hasSVG ? 'litepath' : 'path';

    // create elements
    returnElement = renderer[renderingPath](manager.getContainer('topGroup'));
    // store the _confObject reference
    returnElement._confObject = confObject;
    confObject.thisElement = returnElement;

    // modify few core function

    returnElement._destroy = returnElement.destroy;
    returnElement.destroy = destroyFN;

    returnElement._show = returnElement.show;
    returnElement.show = showFN;

    returnElement._hide = returnElement.hide;
    returnElement.hide = hideFN;

    returnElement._on = returnElement.on;
    returnElement.on = onFN;

    returnElement._drag = returnElement.drag;
    returnElement.drag = onDragFN;

    returnElement._attr = returnElement.attr;
    returnElement.attr = attrFN;

    returnElement._data = returnElement.data;
    returnElement.data = dataFN;

    // add the element to the store
    manager.pointElemStore.push(returnElement);

    elements.topBorder = renderer[renderingPath](manager.getContainer('topGroup'));
    elements.bottom =
      renderer[renderingPath](manager.getContainer('bottomBorderGroup'))
        .attr({
          'stroke-width': 0
        });
    elements.bottomBorder = renderer[renderingPath](manager.getContainer('bottomBorderGroup'));
    elements.frontOuter = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'))
      .attr({
        'stroke-width': 0
      });
    elements.backOuter = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'))
      .attr({
        'stroke-width': 0
      });
    elements.startSlice = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'));
    elements.endSlice = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'));
    elements.frontOuter1 = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'))
      .attr({
        'stroke-width': 0
      });

    // update config object for proper z order
    elements.frontOuter._conf = {
      si: si,
      isStart: 0.5
    };
    elements.frontOuter1._conf = {
      si: si,
      isStart: 0.5
    };
    elements.startSlice._conf = {
      si: si,
      isStart: 0
    };
    elements.endSlice._conf = {
      si: si,
      isStart: 1
    };
    elements.backOuter._conf = {
      si: si,
      isStart: 0.4
    };
    slicingWallsArr.push(elements.startSlice, elements.frontOuter1, elements.frontOuter,
      elements.backOuter, elements.endSlice);
    if (manager.isDoughnut) {
      // innerFront
      elements.frontInner = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'))
        .attr({
          'stroke-width': 0
        });
      elements.backInner = renderer[renderingPath](manager.getContainer('slicingWallsFrontGroup'))
        .attr({
          'stroke-width': 0
        });

      elements.backInner._conf = {
        si: si,
        isStart: 0.5
      };

      elements.frontInner._conf = {
        si: si,
        isStart: 0.4
      };
      slicingWallsArr.push(elements.frontInner, elements.backInner);
    }

    si += 1;
    return returnElement;
  }
  refreshDrawing () {
    let slicingWallsArr = this.slicingWallsArr,
      x = 0,
      sWall,
      ln = slicingWallsArr.length,
      startIndex,
      lastElem2,
      lastElem3,
      index,
      frontGroup = this.getContainer('slicingWallsFrontGroup'),
      backGroup = this.getContainer('slicingWallsBackGroup');

    // sort the slicing walls for z-placing
    slicingWallsArr.sort(elementZSortFn);
    // find the index which cross the pi line
    startIndex = getStartIndex(slicingWallsArr);

    for (; x < ln; x += 1, startIndex += 1) {
      if (startIndex === ln) {
        startIndex = 0;
      }
      sWall = slicingWallsArr[startIndex];
      index = sWall._conf.index;
      if (index < piBy2) {
        frontGroup.appendChild(sWall);
      } else if (index <= pi) {
        if (lastElem2) {
          sWall.insertBefore(lastElem2);
        } else {
          frontGroup.appendChild(sWall);
        }
        lastElem2 = sWall;
      } else if (index <= pi3By2) {
        if (lastElem3) {
          sWall.insertBefore(lastElem3);
        } else {
          backGroup.appendChild(sWall);
        }
        lastElem3 = sWall;
      } else {
        backGroup.appendChild(sWall);
      }
    }
  }
  configure (depth, hasOnePoint, use3DLighting, isDoughnut) {
    var manager = this,
      dataSet = manager.getLinkedParent(),
      renderer = manager.getFromEnv('paper'),
      seriesGroup = dataSet.getContainer('plot-group');

    if (isObject(depth)) {
      depth = depth.depth;
      hasOnePoint = depth.hasOnePoint;
      use3DLighting = depth.use3DLighting;
      isDoughnut = depth.isDoughnut;
    }
    // @todo: need to have pie to daughnut transpose

    // add the values to the instance
    if (!manager.renderer) {
      manager.renderer = renderer;
    }
    manager.hasOnePoint = hasOnePoint;
    manager.use3DLighting = use3DLighting;
    manager.isDoughnut = isDoughnut;
    manager.depth = depth;

    // create required groups
    // TODO: if required create bottom side group
    !manager.getContainer('bottomBorderGroup') && manager.addContainer('bottomBorderGroup',
      renderer.group('bottom-border', seriesGroup));

    // @todo: need to have animate with for dept
    manager.getContainer('bottomBorderGroup').attr({
      transform: 't0,' + depth
    });
    !manager.getContainer('slicingWallsBackGroup') && manager.addContainer('slicingWallsBackGroup',
      renderer.group('slicingWalls-back-Side', seriesGroup));
    !manager.getContainer('slicingWallsFrontGroup') && manager.addContainer('slicingWallsFrontGroup',
      renderer.group('slicingWalls-front-Side', seriesGroup));
    !manager.getContainer('topGroup') && manager.addContainer('topGroup', renderer.group('top-Side',
      seriesGroup));

    // if arrays are not availabel the create the m for first time
    !manager.pointElemStore && (manager.pointElemStore = []);
    !manager.slicingWallsArr && (manager.slicingWallsArr = []);

    // few reusable code
    manager.moveCmdArr = [M];
    manager.lineCmdArr = [L];
    manager.closeCmdArr = [Z];

    manager.colorObjs = [];
  }

  _parseSliceColor (color, alpha, pointConf) {
    var manager = this,
      dark1,
      dark2,
      // dark3,
      dark4,
      dark5,
      dark6,
      light1,
      light2,
      light3,
      light4,
      // light5,
      light6,
      alpha1,
      colorStr1,
      colorStr2,
      alphaStr1,
      alphaStr2,
      alphaStr3,
      colorStr3,
      colorStr4,
      colorStr5,
      alphaFactor = 3,
      lighting3D = manager.use3DLighting,
      cacheStore = lighting3D ? pie3DCacheColorStore.lighting3D : pie3DCacheColorStore.lighting2D,
      colorsObj,
      radiusYFactor = pointConf.radiusYFactor,
      cx = pointConf.cx,
      cy = pointConf.cy,
      rx = pointConf.r,
      ry = rx * radiusYFactor,
      innerRx = pointConf.innerR || 0,
      rightX = cx + rx,
      leftX = cx - rx,
      rightInnerX = cx + innerRx,
      leftInnerX = cx - innerRx;
    if (~color.indexOf('rgb')) {
      color = rawRGBtoHEX(color);
    }
    alpha = alpha || 100;
    alpha1 = alpha / 2;

    // check in cacheStore
    if (cacheStore[color] && cacheStore[color][alpha]) { // if found return the color
      colorsObj = cacheStore[color][alpha];
    } else { // create the color components
      if (!cacheStore[color]) {
        cacheStore[color] = {};
      }
      if (!cacheStore[color][alpha]) {
        cacheStore[color][alpha] = {};
      }
      colorsObj = cacheStore[color][alpha];

      if (lighting3D) {
        dark1 = getDarkColor(color, 80);
        dark2 = getDarkColor(color, 75);
        light1 = getLightColor(color, 85);
        light2 = getLightColor(color, 70);
        light3 = getLightColor(color, 40);

        light4 = getLightColor(color, 50);
        // light5 = getLightColor(color, 30);
        light6 = getLightColor(color, 65);
        // dark3 = getDarkColor(color, 85);
        dark4 = getDarkColor(color, 69);
        dark5 = getDarkColor(color, 75);
        dark6 = getDarkColor(color, 95);
      } else {
        alphaFactor = 10;
        dark1 = getDarkColor(color, 90);
        dark2 = getDarkColor(color, 87);
        light1 = getLightColor(color, 93);
        light2 = getLightColor(color, 87);
        light3 = getLightColor(color, 80);

        light6 = light4 = getLightColor(color, 85);
        // light5 = getLightColor(color, 80);
        dark6 = getDarkColor(color, 85);
        // dark3 = dark6;
        dark4 = getDarkColor(color, 75);
        dark5 = getDarkColor(color, 80);
      }
      colorStr1 = dark2 + COMMASTRING + light1 + COMMASTRING + light2 +
                                    COMMASTRING + light1 + COMMASTRING + dark2;
      alphaStr1 = alpha + COMMASTRING + alpha + COMMASTRING + alpha +
                                      COMMASTRING + alpha + COMMASTRING + alpha;
      colorStr2 = dark2 + COMMASTRING + color + COMMASTRING + light1 +
                                    COMMASTRING + color + COMMASTRING + dark2;
      alphaStr2 = alpha1 + COMMASTRING + alpha1 + COMMASTRING + alpha1 +
                                   COMMASTRING + alpha1 + COMMASTRING + alpha1;
      colorStr3 = dark2 + COMMASTRING + color + COMMASTRING + light3 +
                                     COMMASTRING + color + COMMASTRING + dark2;
      colorStr4 = dark5 + COMMASTRING + light1 + COMMASTRING + light4 +
                                    COMMASTRING + light1 + COMMASTRING + dark4;
      colorStr5 = 'FFFFFF' + COMMASTRING + 'FFFFFF' + COMMASTRING + 'FFFFFF' +
                                    COMMASTRING + 'FFFFFF' + COMMASTRING + 'FFFFFF';
      alphaStr3 = 0 + COMMASTRING + alpha1 / alphaFactor + COMMASTRING + alpha / alphaFactor +
                                   COMMASTRING + alpha1 / alphaFactor + COMMASTRING + 0;

      if (hasSVG) {
        colorsObj.top = {
          FCcolor: {
            gradientUnits: 'userSpaceOnUse',
            radialGradient: true,
            color: light6 + COMMASTRING + dark6,
            alpha: alpha + COMMASTRING + alpha,
            ratio: '0,100'
          }
        };
      } else {
        colorsObj.top = {
          FCcolor: {
            gradientUnits: 'objectBoundingBox',
            color: light2 + COMMASTRING + light2 + COMMASTRING + light1 + COMMASTRING + dark2,
            alpha: alpha + COMMASTRING + alpha + COMMASTRING + alpha + COMMASTRING + alpha,
            angle: -72,
            ratio: '0,8,15,77'
          }
        };
      }

      colorsObj.frontOuter = {
        FCcolor: {
          gradientUnits: 'userSpaceOnUse',
          y1: 0,
          y2: 0,
          color: colorStr4,
          alpha: alphaStr1,
          angle: 0,
          ratio: '0,20,15,15,50'
        }
      };
      colorsObj.backOuter = {
        FCcolor: {
          gradientUnits: 'userSpaceOnUse',
          y1: 0,
          y2: 0,
          color: colorStr3,
          alpha: alphaStr2,
          angle: 0,
          ratio: '0,62,8,8,22'
        }
      };
      colorsObj.frontInner = {
        FCcolor: {
          gradientUnits: 'userSpaceOnUse',
          y1: 0,
          y2: 0,
          color: colorStr2,
          alpha: alphaStr2,
          angle: 0,
          ratio: '0,25,5,5,65'
        }
      };
      colorsObj.backInner = {
        FCcolor: {
          gradientUnits: 'userSpaceOnUse',
          y1: 0,
          y2: 0,
          color: colorStr1,
          alpha: alphaStr1,
          angle: 0,
          ratio: '0,62,8,8,22'
        }
      };
      colorsObj.topBorder = {
        FCcolor: {
          gradientUnits: 'userSpaceOnUse',
          y1: 0,
          y2: 0,
          color: colorStr5,
          alpha: alphaStr3,
          angle: 0,
          ratio: '0,20,15,15,50'
        }
      };
      colorsObj.topInnerBorder = {
        FCcolor: {
          gradientUnits: 'userSpaceOnUse',
          y1: 0,
          y2: 0,
          color: colorStr5,
          alpha: alphaStr3,
          angle: 0,
          ratio: '0,50,15,15,20'
        }
      };
      colorsObj.bottom = toRaphaelColor(convertColor(color, alpha1));
      /** TODO will be changed w. r. t. angle */
      colorsObj.startSlice = toRaphaelColor(convertColor(dark1, alpha));
      colorsObj.endSlice = toRaphaelColor(convertColor(dark1, alpha));
    }

    // check if non color attributes match, else apply them
    if (colorsObj.cx !== cx || colorsObj.cy !== cy || colorsObj.rx !== rx ||
              colorsObj.radiusYFactor !== radiusYFactor || colorsObj.innerRx !== innerRx) {
      // appaly positional properties in colors
      if (hasSVG) {
        colorsObj.top.FCcolor.cx = cx;
        colorsObj.top.FCcolor.cy = cy;
        colorsObj.top.FCcolor.r = rx;
        colorsObj.top.FCcolor.fx = cx - 0.3 * rx;
        colorsObj.top.FCcolor.fy = cy + ry * 1.2;
      }
      colorsObj.topBorder.FCcolor.x1 = colorsObj.backOuter.FCcolor.x1 = colorsObj.frontOuter.FCcolor.x1 =
                  leftX;
      colorsObj.topBorder.FCcolor.x2 = colorsObj.backOuter.FCcolor.x2 = colorsObj.frontOuter.FCcolor.x2 =
                  rightX;
      colorsObj.topInnerBorder.FCcolor.x1 = colorsObj.backInner.FCcolor.x1 =
                  colorsObj.frontInner.FCcolor.x1 = leftInnerX;
      colorsObj.topInnerBorder.FCcolor.x2 = colorsObj.backInner.FCcolor.x2 =
                  colorsObj.frontInner.FCcolor.x2 = rightInnerX;

      // Set positional attributes in color Object
      colorsObj.cx = cx;
      colorsObj.cy = cy;
      colorsObj.rx = rx;
      colorsObj.radiusYFactor = radiusYFactor;
      colorsObj.innerRx = innerRx;
    }

    return colorsObj;
  }

  // eslint-disable-next-line
  allocatePosition () {

  }
  rotate (angle) {
    var manager = this,
      pointElemStore = manager.pointElemStore,
      x = 0, ln = pointElemStore.length, point, confObject;
    if (!manager.hasOnePoint) {
      for (; x < ln; x += 1) {
        point = pointElemStore[x];
        confObject = point._confObject;
        confObject.sAngle += angle;
        confObject.eAngle += angle;
        manager._setSliceShape(confObject);
      }
      manager.refreshDrawing();
    }
  }

  removeSlice (slice) {
    var manager = this,
      pointElemStore = manager.pointElemStore,
      confObject = slice._confObject,
      elements = confObject.elements,
      slicingWallsArr = manager.slicingWallsArr,
      x,
      ln = pointElemStore.length,
      point,
      wallElement;
    // remove the slice from the point store
    for (x = ln - 1; x >= 0; x -= 1) {
      point = pointElemStore[x];
      if (point === slice) {
        pointElemStore.splice(x, 1);
      }
    }
    // remove the side elements from the side wall arr
    ln = slicingWallsArr.length;
    for (x = ln - 1; x >= 0; x -= 1) {
      wallElement = slicingWallsArr[x];
      if (wallElement === elements.startSlice || wallElement === elements.frontOuter1 ||
                  wallElement === elements.frontOuter || wallElement === elements.backInner ||
                  wallElement === elements.endSlice) {
        slicingWallsArr.splice(x, 1);
      }
    }

    // hide corrosponding elements
    slice.hide && slice.hide();

    // store the element in pool for future reuse
    if (!manager._slicePool) {
      manager._slicePool = [];
    }
    manager._slicePool.push(slice);

    manager.refreshDrawing();
  }
  useSliceFromPool () {
    var manager = this,
      slicePool = manager._slicePool || (manager._slicePool = []),
      slicingWallsArr = manager.slicingWallsArr,
      newSlice = false,
      elements;
    if (slicePool.length) {
      newSlice = slicePool.shift();
      // restore the element in point store
      manager.pointElemStore.push(newSlice);
      // show the slice
      newSlice.show();
      // push the side walls in to the side wall array
      elements = newSlice._confObject.elements;
      slicingWallsArr.push(elements.startSlice, elements.frontOuter1, elements.frontOuter);

      elements.backInner && slicingWallsArr.push(elements.backInner);
      slicingWallsArr.push(elements.endSlice);
    }
    return newSlice;
  }
  // This function do the z-index management

  // @todo: needs to be optimize
  _setSliceShape (pointConf, doNotApply) {
    var Pie3DManager = this,
      getArcPath = function (startX, startY, endX, endY, rX, rY, isClockWise, isLargeArc) {
        return (startX == endX && startY == endY) ? [] : [A, rX, rY, 0, isLargeArc, isClockWise, endX, endY];
      },
      startOri = pointConf.sAngle, endOri = pointConf.eAngle,
      start = normalizeAngle(startOri),
      end = normalizeAngle(endOri),
      scaleAngle,
      startCos, startSin, endCos, endSin, startOuterX, startOuterY,
      startOuterTopClipX, startOuterTopClipY, endOuterTopClipX, endOuterTopClipY,
      startInnerX, startInnerY, endInnerX, endInnerY, startInnerY1, endInnerY1,
      borderThickness = 1,
      isDoughnut = Pie3DManager.isDoughnut,
      radiusYFactor = pointConf.radiusYFactor,
      cx = pointConf.cx,
      cy = pointConf.cy,
      rx = pointConf.r,
      ry = rx * radiusYFactor,
      topCliprx = rx + (hasSVG ? -borderThickness : 2),
      topClipry = ry + (hasSVG ? -borderThickness : 2),
      innerRx = pointConf.innerR || 0,
      innerRy = innerRx * radiusYFactor,
      depth = Pie3DManager.depth,
      depthY = depth + cy,
      rightX = cx + rx,
      leftX = cx - rx,
      rightInnerX = cx + innerRx,
      leftInnerX = cx - innerRx,
      topY = cy - ry,
      bottomY = depthY + ry,
      clipPathforNoClip = [M, leftInnerX, topY, L, leftInnerX, bottomY, Z],
      elements = pointConf.elements,
      startOuterY1, endOuterX, endOuterY, endOuterY1,
      tempArr1, tempArr2, tempArr3, tempArr4, tempArr5, tempArr6,
      moveCmdArr,
      lineCmdArr,
      closeCmdArr,
      centerPoint,
      leftPoint,
      topPoint,
      rightPoint,
      bottomPoint,
      leftDepthPoint,
      rightDepthPoint,
      leftInnerPoint,
      rightInnerPoint,
      leftInnerDepthPoint,
      rightInnerDepthPoint,
      pathAttrString = 'path',
      middleAngle = (start + end) / 2, // not applicable for the slices that are crossing the 0deg
      frontOuterIndex,
      BackOuterIndex,
      crossed2Pi = start > end;

    startCos = mathCos(start);
    startSin = mathSin(start);
    endCos = mathCos(end);
    endSin = mathSin(end);

    startOuterX = cx + (rx * startCos);
    startOuterY = cy + (ry * startSin);
    startOuterTopClipX = cx + (topCliprx * startCos);
    startOuterTopClipY = cy + (topClipry * startSin);
    startOuterY1 = startOuterY + depth;
    endOuterX = cx + (rx * endCos);
    endOuterY = cy + (ry * endSin);
    endOuterTopClipX = cx + (topCliprx * endCos);
    endOuterTopClipY = cy + (topClipry * endSin);
    endOuterY1 = endOuterY + depth;

    if (isDoughnut) { // doughnut like slice
      startInnerX = cx + (innerRx * startCos);
      startInnerY = cy + (innerRy * startSin);
      startInnerY1 = startInnerY + depth;
      endInnerX = cx + (innerRx * endCos);
      endInnerY = cy + (innerRy * endSin);
      endInnerY1 = endInnerY + depth;
      pointConf.startSlice = [M, startOuterX, startOuterY, L, startOuterX, startOuterY1, startInnerX,
        startInnerY1, startInnerX, startInnerY, Z];
      pointConf.endSlice = [M, endOuterX, endOuterY, L, endOuterX, endOuterY1, endInnerX, endInnerY1,
        endInnerX, endInnerY, Z];
    } else {
      pointConf.startSlice = [M, startOuterX, startOuterY, L, startOuterX, startOuterY1, cx, depthY, cx,
        cy, Z];
      pointConf.endSlice = [M, endOuterX, endOuterY, L, endOuterX, endOuterY1, cx, depthY, cx, cy, Z];
    }

    if (hasSVG) {
      scaleAngle = getAbsScaleAngle(start, end);
      // create the clip for top and bottom
      if (!isDoughnut) {
        pointConf.clipTopPath = [[M, startOuterX, startOuterY,
          A, rx, ry, 0, (scaleAngle > pi ? 1 : 0), 1, endOuterX, endOuterY,
          L, cx, cy,
          Z]];
      } else {
        pointConf.clipTopPath = [[M, startOuterX, startOuterY, A, rx, ry, 0, (scaleAngle > pi ? 1 : 0),
          1, endOuterX, endOuterY, L, endInnerX, endInnerY, A, innerRx, innerRy,
          0, (scaleAngle > pi ? 1 : 0), 0, startInnerX, startInnerY, Z]];
      }

      pointConf.clipOuterFrontPath1 = [clipPathforNoClip];

      pointConf.clipTopBorderPath = [[M, startOuterTopClipX, startOuterTopClipY, A, topCliprx, topClipry,
        0, (scaleAngle > pi ? 1 : 0), 1, endOuterTopClipX, endOuterTopClipY,
        L, endOuterX, endOuterY, endOuterX, endOuterY + borderThickness, A,
        rx, ry, 0, (scaleAngle > pi ? 1 : 0), 0, startOuterX, startOuterY +
                                             borderThickness, L, startOuterX, startOuterY, Z]];

      if (startOri != endOri) {
        if (start > end) { // crossed the 0 deg line
          if (start < pi) { // crossed the 180 deg line also
            pointConf.clipOuterFrontPath = [[M, rightX, cy,
              A, rx, ry, 0, 0, 1, endOuterX, endOuterY,
              V, depth,
              A, rx, ry, 0, 0, 0, rightX, cy + depth,
              Z]];
            pointConf.clipOuterFrontPath1 = [[M, leftX, cy,
              A, rx, ry, 0, 0, 0, startOuterX, startOuterY,
              V, depth,
              A, rx, ry, 0, 0, 1, leftX, cy + depth,
              Z]];
            pointConf.clipOuterBackPath = [[M, rightX, cy,
              A, rx, ry, 0, 1, 0, leftX, cy,
              V, depth,
              A, rx, ry, 0, 1, 1, rightX, cy + depth,
              Z]];
            if (isDoughnut) {
              pointConf.clipInnerBackPath = [[M, rightInnerX, cy,
                A, innerRx, innerRy, 0, 1, 0, leftInnerX, cy,
                V, depth,
                A, innerRx, innerRy, 0, 1, 1, rightInnerX, cy +
                                                             depth, Z]];

              pointConf.clipInnerFrontPath = [[M, rightInnerX, cy,
                A, innerRx, innerRy, 0, 0, 1, endInnerX, endInnerY,
                V, depth,
                A, innerRx, innerRy, 0, 0, 0, rightInnerX, cy +
                                                              depth, Z,
                M, leftInnerX, cy,
                A, innerRx, innerRy, 0, 0, 0, startInnerX,
                startInnerY, V, depth,
                A, innerRx, innerRy, 0, 0, 1, leftInnerX, cy +
                                                              depth, Z]];
            }
          } else if (end > pi) { // crossed the 180 deg line also
            pointConf.clipOuterFrontPath = [[M, rightX, cy,
              A, rx, ry, 0, 1, 1, leftX, cy,
              V, depth,
              A, rx, ry, 0, 1, 0, rightX, cy + depth,
              Z]];
            pointConf.clipOuterBackPath = [[M, leftX, cy,
              A, rx, ry, 0, 0, 1, endOuterX, endOuterY,
              V, depth,
              A, rx, ry, 0, 0, 0, leftX, cy + depth,
              Z,
              M, rightX, cy,
              A, rx, ry, 0, 0, 0, startOuterX, startOuterY,
              V, depth,
              A, rx, ry, 0, 0, 1, rightX, cy + depth,
              Z]];
            if (isDoughnut) {
              pointConf.clipInnerFrontPath = [[M, rightInnerX, cy,
                A, innerRx, innerRy, 0, 1, 1, leftInnerX, cy,
                V, depth,
                A, innerRx, innerRy, 0, 1, 0, rightInnerX, cy +
                                                              depth, Z]];

              pointConf.clipInnerBackPath = [[M, leftInnerX, cy,
                A, innerRx, innerRy, 0, 0, 1, endInnerX, endInnerY,
                V, depth,
                A, innerRx, innerRy, 0, 0, 0, leftInnerX, cy +
                                                             depth, Z,
                M, rightInnerX, cy,
                A, innerRx, innerRy, 0, 0, 0, startInnerX,
                startInnerY, V, depth,
                A, innerRx, innerRy, 0, 0, 1, rightInnerX, cy +
                                                             depth, Z]];
            }
          } else {
            pointConf.clipOuterFrontPath = [[M, rightX, cy,
              A, rx, ry, 0, 0, 1, endOuterX, endOuterY,
              V, depth,
              A, rx, ry, 0, 0, 0, rightX, cy + depth,
              Z]];
            pointConf.clipOuterBackPath = [[M, startOuterX, startOuterY,
              A, rx, ry, 0, 0, 1, rightX, cy,
              V, depth,
              A, rx, ry, 0, 0, 0, startOuterX, startOuterY1,
              Z]];
            if (isDoughnut) {
              pointConf.clipInnerFrontPath = [[M, rightInnerX, cy,
                A, innerRx, innerRy, 0, 0, 1, endInnerX, endInnerY,
                V, depth,
                A, innerRx, innerRy, 0, 0, 0, rightInnerX, cy +
                                                              depth, Z]];

              pointConf.clipInnerBackPath = [[M, startInnerX, startInnerY,
                A, innerRx, innerRy, 0, 0, 1, rightInnerX, cy,
                V, depth,
                A, innerRx, innerRy, 0, 0, 0, startInnerX,
                startInnerY1, Z]];
            }
          }
        } else if (start < pi) {
          if (end > pi) { // crossed the 180 deg line only
            pointConf.clipOuterFrontPath = [[M, startOuterX, startOuterY,
              A, rx, ry, 0, 0, 1, leftX, cy,
              V, depth,
              A, rx, ry, 0, 0, 0, startOuterX, startOuterY1,
              Z]];
            pointConf.clipOuterBackPath = [[M, leftX, cy,
              A, rx, ry, 0, 0, 1, endOuterX, endOuterY,
              V, depth,
              A, rx, ry, 0, 0, 0, leftX, cy + depth,
              Z]];
            if (isDoughnut) {
              pointConf.clipInnerFrontPath = [[M, startInnerX, startInnerY,
                A, innerRx, innerRy, 0, 0, 1, leftInnerX,
                cy, V, depth,
                A, innerRx, innerRy, 0, 0, 0, startInnerX,
                startInnerY1, Z]];
              pointConf.clipInnerBackPath = [[M, leftInnerX, cy,
                A, innerRx, innerRy, 0, 0, 1, endInnerX,
                endInnerY, V, depth,
                A, innerRx, innerRy, 0, 0, 0, leftInnerX,
                cy + depth, Z]];
            }
          } else { // haven't crossed any thing
            pointConf.clipOuterFrontPath = [[M, startOuterX, startOuterY,
              A, rx, ry, 0, 0, 1, endOuterX, endOuterY,
              V, depth,
              A, rx, ry, 0, 0, 0, startOuterX, startOuterY1,
              Z]];
            pointConf.clipOuterBackPath = [clipPathforNoClip];

            if (isDoughnut) {
              pointConf.clipInnerFrontPath = [[M, startInnerX, startInnerY,
                A, innerRx, innerRy, 0, 0, 1, endInnerX, endInnerY,
                V, depth,
                A, innerRx, innerRy, 0, 0, 0, startInnerX,
                startInnerY1, Z]];

              pointConf.clipInnerBackPath = [clipPathforNoClip];
            }
          }
        } else { // haven't crossed any thing
          pointConf.clipOuterFrontPath = [clipPathforNoClip];
          pointConf.clipOuterBackPath = [[M, startOuterX, startOuterY,
            A, rx, ry, 0, 0, 1, endOuterX, endOuterY,
            V, depth,
            A, rx, ry, 0, 0, 0, startOuterX, startOuterY1,
            Z]];
          if (isDoughnut) {
            pointConf.clipInnerFrontPath = [clipPathforNoClip];

            pointConf.clipInnerBackPath = [[M, startInnerX, startInnerY,
              A, innerRx, innerRy, 0, 0, 1, endInnerX, endInnerY,
              V, depth,
              A, innerRx, innerRy, 0, 0, 0, startInnerX, startInnerY1,
              Z]];
          }
        }
      } else { // zero Pie
        pointConf.clipOuterFrontPath = pointConf.clipOuterBackPath = pointConf.clipInnerBackPath =
                  pointConf.clipInnerFrontPath = [clipPathforNoClip];
      }

      pathAttrString = 'litepath';
      pointConf.clipBottomBorderPath = pointConf.clipTopPath;
      pointConf.startSlice = [pointConf.startSlice];
      pointConf.endSlice = [pointConf.endSlice];
    } else { // for VML
      moveCmdArr = Pie3DManager.moveCmdArr;
      lineCmdArr = Pie3DManager.lineCmdArr;
      closeCmdArr = Pie3DManager.closeCmdArr;
      centerPoint = [cx, cy];
      leftPoint = [leftX, cy];
      topPoint = [cx, topY];
      rightPoint = [rightX, cy];
      bottomPoint = [cx, cy + ry];
      leftDepthPoint = [leftX, depthY];
      rightDepthPoint = [rightX, depthY];
      leftInnerPoint = [leftInnerX, cy];
      rightInnerPoint = [rightInnerX, cy];
      leftInnerDepthPoint = [leftInnerX, depthY];
      rightInnerDepthPoint = [rightInnerX, depthY];
      pointConf.clipOuterFrontPath1 = [];
      if (startOri != endOri) {
        if (start > end) { // crossed the 0 deg line
          if (start < pi) { // crossed the 180 deg line also
            tempArr1 = getArcPath(startOuterX, startOuterY, leftX, cy, rx, ry, 1, 0);
            tempArr3 = getArcPath(leftX, cy, rightX, cy, rx, ry, 1, 0);
            tempArr5 = getArcPath(rightX, cy, endOuterX, endOuterY, rx, ry, 1, 0);
            pointConf.clipOuterBackPath = moveCmdArr.concat(leftPoint, tempArr3, lineCmdArr,
              rightDepthPoint, getArcPath(rightX, depthY, leftX, depthY, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipOuterFrontPath1 = moveCmdArr.concat([startOuterX, startOuterY], tempArr1, lineCmdArr,
              leftDepthPoint, getArcPath(leftX, depthY, startOuterX, startOuterY1, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipOuterFrontPath = moveCmdArr.concat(rightPoint, tempArr5, lineCmdArr, [endOuterX, endOuterY1],
              getArcPath(endOuterX, endOuterY1, rightX, depthY, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipTopBorderPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1,
              tempArr3, tempArr5);
            if (isDoughnut) {
              tempArr2 = getArcPath(endInnerX, endInnerY, rightInnerX, cy, innerRx, innerRy, 0, 0);
              tempArr4 = getArcPath(rightInnerX, cy, leftInnerX, cy, innerRx, innerRy, 0, 0);
              tempArr6 = getArcPath(leftInnerX, cy, startInnerX, startInnerY, innerRx, innerRy, 0, 0);
              pointConf.clipInnerBackPath = moveCmdArr.concat(rightInnerPoint, tempArr4, lineCmdArr, leftInnerDepthPoint,
                getArcPath(leftInnerX, depthY, rightInnerX, depthY, innerRx, innerRy, 1, 0), closeCmdArr);
              pointConf.clipInnerFrontPath = moveCmdArr.concat(leftInnerPoint, tempArr6,
                lineCmdArr, [startInnerX, startInnerY1], getArcPath(startInnerX,
                  startInnerY1, leftInnerX, depthY, innerRx, innerRy, 1, 0), closeCmdArr,
                moveCmdArr, [endInnerX, endInnerY], tempArr2, lineCmdArr, rightInnerDepthPoint,
                getArcPath(rightInnerX, depthY, endInnerX, endInnerY1, innerRx, innerRy, 1, 0), closeCmdArr);
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, [endInnerX,
                endInnerY], tempArr2, tempArr4, tempArr6, closeCmdArr);
              pointConf.clipTopBorderPath = pointConf.clipTopBorderPath.concat(moveCmdArr,
                [endInnerX, endInnerY], tempArr2, tempArr4, tempArr6);
            } else {
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, centerPoint,
                closeCmdArr);
            }
          } else if (end > pi) { // crossed the 180 deg line also
            tempArr1 = getArcPath(startOuterX, startOuterY, rightX, cy, rx, ry, 1, 0);
            tempArr3 = getArcPath(rightX, cy, leftX, cy, rx, ry, 1, 0);
            tempArr5 = getArcPath(leftX, cy, endOuterX, endOuterY, rx, ry, 1, 0);
            pointConf.clipOuterFrontPath = moveCmdArr.concat(rightPoint, tempArr3, lineCmdArr,
              leftDepthPoint, getArcPath(leftX, depthY, rightX, depthY, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipOuterBackPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1,
              lineCmdArr, rightDepthPoint, getArcPath(rightX, depthY, startOuterX,
                startOuterY1, rx, ry, 0, 0), closeCmdArr, moveCmdArr, leftPoint,
              tempArr5, lineCmdArr, [endOuterX, endOuterY1], getArcPath(endOuterX,
                endOuterY1, leftX, depthY, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipTopBorderPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1,
              tempArr3, tempArr5);
            if (isDoughnut) {
              tempArr2 = getArcPath(endInnerX, endInnerY, leftInnerX, cy, innerRx, innerRy, 0, 0);
              tempArr4 = getArcPath(leftInnerX, cy, rightInnerX, cy, innerRx, innerRy, 0, 0);
              tempArr6 = getArcPath(rightInnerX, cy, startInnerX, startInnerY, innerRx, innerRy, 0, 0);
              pointConf.clipInnerFrontPath = moveCmdArr.concat(leftInnerPoint, tempArr4, lineCmdArr, rightInnerDepthPoint,
                getArcPath(rightInnerX, depthY, leftInnerX, depthY, innerRx, innerRy, 1, 0), closeCmdArr);
              pointConf.clipInnerBackPath = moveCmdArr.concat(rightInnerPoint, tempArr6,
                lineCmdArr, [startInnerX, startInnerY1], getArcPath(startInnerX,
                  startInnerY1, rightInnerX, depthY, innerRx, innerRy, 1, 0),
                closeCmdArr, moveCmdArr, [endInnerX, endInnerY], tempArr2, lineCmdArr,
                leftInnerDepthPoint, getArcPath(leftInnerX, depthY,
                  endInnerX, endInnerY1, innerRx, innerRy, 1, 0), closeCmdArr);

              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, [endInnerX,
                endInnerY], tempArr2, tempArr4, tempArr6, closeCmdArr);
              pointConf.clipTopBorderPath = pointConf.clipTopBorderPath.concat(moveCmdArr,
                [endInnerX, endInnerY], tempArr2, tempArr4, tempArr6);
            } else {
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, centerPoint,
                closeCmdArr);
            }
          } else {
            tempArr1 = getArcPath(startOuterX, startOuterY, rightX, cy, rx, ry, 1, 0);
            tempArr3 = getArcPath(rightX, cy, endOuterX, endOuterY, rx, ry, 1, 0);
            pointConf.clipOuterFrontPath = moveCmdArr.concat(rightPoint, tempArr3, lineCmdArr, [endOuterX, endOuterY1],
              getArcPath(endOuterX, endOuterY1, rightX, depthY, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipOuterBackPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1,
              lineCmdArr, rightDepthPoint, getArcPath(rightX, depthY,
                startOuterX, startOuterY1, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipTopBorderPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1,
              tempArr3);
            if (isDoughnut) {
              tempArr2 = getArcPath(endInnerX, endInnerY, rightInnerX, cy, innerRx, innerRy, 0, 0);
              tempArr4 = getArcPath(rightInnerX, cy, startInnerX, startInnerY, innerRx, innerRy, 0, 0);
              pointConf.clipInnerFrontPath = moveCmdArr.concat([endInnerX, endInnerY], tempArr2, lineCmdArr,
                rightInnerDepthPoint, getArcPath(rightInnerX, depthY, endInnerX, endInnerY1,
                  innerRx, innerRy, 1, 0), closeCmdArr);
              pointConf.clipInnerBackPath = moveCmdArr.concat(rightInnerPoint, tempArr4, lineCmdArr,
                [startInnerX, startInnerY1],
                getArcPath(startInnerX, startInnerY1, rightInnerX, depthY, innerRx, innerRy, 1, 0),
                closeCmdArr);
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, [endInnerX,
                endInnerY], tempArr2, tempArr4, closeCmdArr);
              pointConf.clipTopBorderPath = pointConf.clipTopBorderPath.concat(moveCmdArr,
                [endInnerX, endInnerY], tempArr2, tempArr4);
            } else {
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, centerPoint,
                closeCmdArr);
            }
          }
        } else if (start < pi) {
          if (end > pi) { // crossed the 180 deg line only
            tempArr1 = getArcPath(startOuterX, startOuterY, leftX, cy, rx, ry, 1, 0);
            tempArr3 = getArcPath(leftX, cy, endOuterX, endOuterY, rx, ry, 1, 0);
            pointConf.clipOuterBackPath = moveCmdArr.concat(leftPoint, tempArr3, lineCmdArr, [endOuterX, endOuterY1],
              getArcPath(endOuterX, endOuterY1, leftX, depthY, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipOuterFrontPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1, lineCmdArr,
              leftDepthPoint, getArcPath(leftX, depthY, startOuterX, startOuterY1, rx, ry, 0, 0), closeCmdArr);
            pointConf.clipTopBorderPath = moveCmdArr.concat([startOuterX, startOuterY], tempArr1,
              tempArr3);
            if (isDoughnut) {
              tempArr2 = getArcPath(endInnerX, endInnerY, leftInnerX, cy, innerRx, innerRy, 0, 0);
              tempArr4 = getArcPath(leftInnerX, cy, startInnerX, startInnerY, innerRx, innerRy, 0, 0);
              pointConf.clipInnerBackPath = moveCmdArr.concat([endInnerX, endInnerY], tempArr2,
                lineCmdArr, leftInnerDepthPoint,
                getArcPath(leftInnerX, depthY, endInnerX, endInnerY1, innerRx,
                  innerRy, 1, 0), closeCmdArr);
              pointConf.clipInnerFrontPath = moveCmdArr.concat(leftInnerPoint, tempArr4,
                lineCmdArr, [startInnerX, startInnerY1], getArcPath(startInnerX,
                  startInnerY1, leftInnerX, depthY, innerRx, innerRy, 1, 0),
                closeCmdArr);
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, [endInnerX,
                endInnerY], tempArr2, tempArr4, closeCmdArr);
              pointConf.clipTopBorderPath = pointConf.clipTopBorderPath.concat(moveCmdArr,
                [endInnerX, endInnerY], tempArr2, tempArr4);
            } else {
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, centerPoint,
                closeCmdArr);
            }
          } else { // haven't crossed any thing
            tempArr1 = getArcPath(startOuterX, startOuterY, endOuterX, endOuterY, rx, ry, 1, 0);
            pointConf.clipOuterBackPath = moveCmdArr.concat([startOuterX, startOuterY]);
            pointConf.clipTopBorderPath = pointConf.clipOuterBackPath.concat(tempArr1);
            pointConf.clipOuterFrontPath = pointConf.clipTopBorderPath.concat(lineCmdArr,
              [endOuterX, endOuterY1], getArcPath(endOuterX,
                endOuterY1, startOuterX, startOuterY1, rx, ry, 0, 0), closeCmdArr);
            if (isDoughnut) {
              tempArr2 = getArcPath(endInnerX, endInnerY, startInnerX, startInnerY, innerRx, innerRy, 0, 0);
              pointConf.clipInnerBackPath = moveCmdArr.concat([endInnerX, endInnerY]);
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, [endInnerX,
                endInnerY], tempArr2, closeCmdArr);
              pointConf.clipTopBorderPath = pointConf.clipTopBorderPath.concat(moveCmdArr,
                [endInnerX, endInnerY], tempArr2);
              pointConf.clipInnerFrontPath = pointConf.clipInnerBackPath.concat(tempArr2,
                lineCmdArr, [startInnerX, startInnerY1], getArcPath(startInnerX,
                  startInnerY1, endInnerX, endInnerY1, innerRx, innerRy, 1, 0), closeCmdArr);
            } else {
              pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, centerPoint,
                closeCmdArr);
            }
          }
        } else { // haven't crossed any thing
          tempArr1 = getArcPath(startOuterX, startOuterY, endOuterX, endOuterY, rx, ry, 1, 0);
          pointConf.clipOuterFrontPath = moveCmdArr.concat([startOuterX, startOuterY]);
          pointConf.clipTopBorderPath = pointConf.clipOuterFrontPath.concat(tempArr1);
          pointConf.clipOuterBackPath = pointConf.clipTopBorderPath.concat(lineCmdArr,
            [endOuterX, endOuterY1], getArcPath(endOuterX, endOuterY1, startOuterX,
              startOuterY1, rx, ry, 0, 0), closeCmdArr);
          if (isDoughnut) {
            tempArr2 = getArcPath(endInnerX, endInnerY, startInnerX, startInnerY, innerRx, innerRy, 0, 0);
            pointConf.clipInnerFrontPath = moveCmdArr.concat([endInnerX, endInnerY]);
            pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, [endInnerX,
              endInnerY], tempArr2, closeCmdArr);
            pointConf.clipTopBorderPath = pointConf.clipTopBorderPath.concat(
              pointConf.clipInnerFrontPath, tempArr2);
            pointConf.clipInnerBackPath = pointConf.clipInnerFrontPath.concat(tempArr2,
              lineCmdArr, [startInnerX, startInnerY1], getArcPath(startInnerX,
                startInnerY1, endInnerX, endInnerY1, innerRx, innerRy, 1, 0), closeCmdArr);
          } else {
            pointConf.clipTopPath = pointConf.clipTopBorderPath.concat(lineCmdArr, centerPoint,
              closeCmdArr);
          }
        }
        // enlarge the bounded box so that the gradient works perfactly
        tempArr1 = moveCmdArr.concat(leftPoint, lineCmdArr, rightPoint);
        tempArr2 = moveCmdArr.concat(topPoint, lineCmdArr, bottomPoint);
        pointConf.clipTopPath = pointConf.clipTopPath.concat(tempArr1, tempArr2);
        pointConf.clipOuterFrontPath = pointConf.clipOuterFrontPath.concat(tempArr1);
        pointConf.clipOuterFrontPath1 = pointConf.clipOuterFrontPath1.concat(tempArr1);
        pointConf.clipOuterBackPath = pointConf.clipOuterBackPath.concat(tempArr1);

        if (isDoughnut) {
          tempArr2 = moveCmdArr.concat(leftInnerPoint, lineCmdArr, rightInnerPoint);
          pointConf.clipInnerFrontPath = pointConf.clipInnerFrontPath.concat(tempArr2);
          pointConf.clipInnerBackPath = pointConf.clipInnerBackPath.concat(tempArr2);
        }
      } else { // zero Pie
        pointConf.clipTopPath =
                  pointConf.clipOuterFrontPath =
                  pointConf.clipOuterBackPath = [];
        if (isDoughnut) {
          pointConf.clipInnerFrontPath =
                      pointConf.clipInnerBackPath = [];
        }
      }

      pointConf.clipBottomBorderPath = pointConf.clipTopBorderPath;
    }

    // now apply the changes
    if (!doNotApply) {
      elements.startSlice._conf.index = start;
      elements.endSlice._conf.index = end;
      elements.backOuter._conf.index = BackOuterIndex =
               (crossed2Pi && (start <= pi3By2 || end > pi3By2)) ||
               (start <= pi3By2 && end > pi3By2) ? pi3By2 : (start > pi ? start : end);

      elements.frontOuter._conf.index = frontOuterIndex = end <= piBy2 ? end : ((start > end ||
                  start <= piBy2) ? piBy2 : start);
      elements.frontOuter1._conf.index = start;
      elements.frontOuter1._conf.cIndex = pi;
      if (start > end) {
        elements.backOuter._conf.cIndex = start < pi3By2 ? pi3By2 : pi2;
        elements.startSlice._conf.cIndex = start < pi ? (start + pi) / 2 : (start + pi2) / 2;
        elements.endSlice._conf.cIndex = elements.frontOuter._conf.cIndex = 0;
      } else {
        elements.backOuter._conf.cIndex = elements.startSlice._conf.cIndex =
                  elements.endSlice._conf.cIndex = elements.frontOuter._conf.cIndex = middleAngle;
      }

      if (scaleAngle > pi) {
        elements.frontOuter1.show().attr(
          pathAttrString, pointConf.clipOuterFrontPath1
        );
      } else {
        elements.frontOuter1.hide();
      }
      pointConf.thisElement._attr(
        pathAttrString, pointConf.clipTopPath
      );
      elements.bottom.attr(
        pathAttrString, pointConf.clipTopPath
      );
      elements.bottomBorder.attr(
        pathAttrString, pointConf.clipBottomBorderPath
      );

      elements.topBorder && elements.topBorder.attr(
        pathAttrString, pointConf.clipTopBorderPath
      );
      elements.frontOuter.attr(
        pathAttrString, pointConf.clipOuterFrontPath
      );
      elements.backOuter.attr(
        pathAttrString, pointConf.clipOuterBackPath
      );

      if (isDoughnut) {
        elements.backInner.attr(
          pathAttrString, pointConf.clipInnerBackPath
        );
        elements.frontInner.attr(
          pathAttrString, pointConf.clipInnerFrontPath
        );
        elements.backInner._conf.index = BackOuterIndex;
        elements.frontInner._conf.index = frontOuterIndex;
        if (start > end) {
          elements.backInner._conf.cIndex = pi2;
          elements.frontInner._conf.cIndex = 0;
        } else {
          elements.backInner._conf.cIndex =
                       elements.frontInner._conf.cIndex = middleAngle;
        }
      }

      if (Pie3DManager.hasOnePoint) {
        elements.startSlice.hide();
        elements.endSlice.hide();
      } else {
        elements.startSlice.attr(
          pathAttrString, pointConf.startSlice
        ).show();
        elements.endSlice.attr(
          pathAttrString, pointConf.endSlice
        ).show();
      }
    }
  }

  _setSliceCosmetics (pointConf) {
    var manager = this,
      topElement = pointConf.thisElement,
      showBorderEffect = pointConf.showBorderEffect,
      elements = pointConf.elements,
      colorObj,
      borderColor = convertColor(pointConf.borderColor, pluckNumber(pointConf.borderAlpha,
        pointConf.alpha)),
      borderWidth = pointConf.borderWidth,
      topAttrObj;
    if (!pointConf.color) {
      return;
    }
    // in case of hover, color is color object, have property color containing values
    pointConf.color = pointConf.color.color ? pointConf.color.color : pointConf.color;
    colorObj = manager._parseSliceColor(pointConf.color, pointConf.alpha, pointConf);
    if (hasSVG) {
      topAttrObj = {fill: toRaphaelColor(colorObj.top), 'stroke-width': 0};

      if (showBorderEffect) {
        elements.topBorder.show().attr({
          fill: toRaphaelColor(colorObj.topBorder),
          'stroke-width': 0
        });
      } else {
        elements.topBorder.hide();
        topAttrObj.stroke = borderColor;
        topAttrObj['stroke-width'] = borderWidth;
      }

      // top
      topElement._attr(topAttrObj);
    } else {
      topElement._attr({
        fill: toRaphaelColor(colorObj.top),
        'stroke-width': 0
      });
      // top border
      elements.topBorder.attr({
        stroke: borderColor,
        'stroke-width': borderWidth
      });
    }

    // bottom
    elements.bottom.attr({
      fill: toRaphaelColor(colorObj.bottom)
    });

    // bottom
    elements.bottomBorder.attr({
      stroke: borderColor,
      'stroke-width': borderWidth
    });

    elements.frontOuter.attr({
      fill: toRaphaelColor(colorObj.frontOuter)
    });
    elements.frontOuter1.attr({
      fill: toRaphaelColor(colorObj.frontOuter)
    });

    // outerback
    elements.backOuter.attr({
      fill: toRaphaelColor(colorObj.backOuter)
    });

    // startSlice
    // whenAtBack
    elements.startSlice.attr({
      fill: toRaphaelColor(colorObj.startSlice),
      stroke: borderColor,
      'stroke-width': borderWidth
    });

    // endSlice
    // whenAtBack
    elements.endSlice.attr({
      fill: toRaphaelColor(colorObj.endSlice),
      stroke: borderColor,
      'stroke-width': borderWidth
    });
    if (manager.isDoughnut) {
      // innerFront
      elements.frontInner.attr({
        fill: toRaphaelColor(colorObj.frontInner)
      });

      elements.backInner.attr({
        fill: toRaphaelColor(colorObj.backInner)
      });
    }
  }
}
export default Pie3DDataset;
